import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';

(function($){
$(document).ready(function(){

	// ─── Variables ────────────────────────────────────────────────────────────
	const $html  = $('html');
	const $body  = $('body');
	const $scrollTop = $('#back-to-top');
	const isDevice   = $(window).width() < 960;

	// ─── Global UI ────────────────────────────────────────────────────────────

	$body.removeClass('no-js');

	// ─── a11y: nume accesibil pe săgețile slick ─────────────────────────────────
	// Multe slidere au arrows:true; săgețile generate de slick n-au text/aria-label
	// (button-name în Lighthouse). Le etichetăm global, la init/resize + la load.
	function evxLabelSlickArrows( $ctx ) {
		( $ctx ? $ctx.find( '.slick-arrow' ) : $( '.slick-arrow' ) )
			.filter( function () { return ! this.getAttribute( 'aria-label' ); } )
			.each( function () {
				this.setAttribute( 'aria-label',
					this.classList.contains( 'slick-prev' ) ? 'Slide anterior' : 'Slide următor' );
			} );
	}
	$( document ).on( 'init setPosition afterChange', '.slick-slider', function () {
		evxLabelSlickArrows( $( this ) );
	} );
	$( window ).on( 'load', function () { evxLabelSlickArrows(); } );

	// Butoane vechi (.btn-green / a.btn-primary) + butoanele native Elementor
	// (.elementor-button) → design nou btn-fill, fara a edita continutul.
	// Reconstruieste markup-ul exact ca evx_btn_fill() → mosteneste CSS-ul + animatia.
	// Idempotent. Icon: icon-arrow-right-alt. Exclude orice buton cu clasa .no-btnfill.
	(function() {
		// a.btn-primary inclus, dar NU button.btn-primary (= submit-uri de formular).
		var olds = document.querySelectorAll(
			'a.btn-green:not(.no-btnfill), button.btn-green:not(.no-btnfill),' +
			'a.btn-primary:not(.no-btnfill), a.elementor-button:not(.no-btnfill),' +
			'a.quiz__btn-next:not(.no-btnfill)'
		);
		if ( ! olds.length ) return;
		var ICON = 'icon-arrow-right-alt';

		olds.forEach(function( el ) {
			if ( el.classList.contains('btn-fill') ) return;
			// Toggle-uri Bootstrap (collapse/tab/dropdown/modal) — controale, nu CTA-uri.
			// Conversia le-ar distruge structura interna (ex. accordion fise-tehnice).
			if ( el.hasAttribute('data-bs-toggle') ) return;

			// La butoanele Elementor textul e in .elementor-button-text
			var textEl = el.querySelector('.elementor-button-text');
			var text   = ( textEl ? textEl.textContent : ( el.textContent || '' ) ).trim();

			el.innerHTML =
				'<span class="btn-fill__icon"><span class="btn-fill__icon-track">' +
					'<span class="btn-fill__icon-item"><i class="' + ICON + '" aria-hidden="true"></i></span>' +
					'<span class="btn-fill__icon-item" aria-hidden="true"><i class="' + ICON + '" aria-hidden="true"></i></span>' +
				'</span></span>' +
				'<span class="btn-fill__label"><span class="btn-fill__label-track">' +
					'<span class="btn-fill__label-item"></span>' +
					'<span class="btn-fill__label-item" aria-hidden="true"></span>' +
				'</span></span>';

			// Text setat via textContent (anti-XSS) in ambele track-uri
			el.querySelectorAll('.btn-fill__label-item').forEach(function( s ) { s.textContent = text; });

			el.classList.remove('btn', 'btn-lg', 'btn-sm', 'btn-green', 'btn-primary', 'btn-secondary', 'text-white');
			// Scoate: clasele Elementor (.elementor-button + .elementor-size-*) → CSS-ul
			// verde Elementor nu mai aplica; SI utilitarele de padding (px-*, py-*, p-*…)
			// care au !important si strica padding-ul propriu al btn-fill (ex. icon mutat).
			Array.prototype.slice.call( el.classList ).forEach(function( c ) {
				if ( /^elementor-(button|size)/.test( c ) || /^p[xytbse]?-/.test( c ) ) {
					el.classList.remove( c );
				}
			});
			el.classList.add('btn-fill');
		});
	})();

	// Header — comportament configurabil din ACF (data-header-behavior):
	//   scroll_normal → header in flux, fara JS (default)
	//   scroll_hide   → headroom: ascunde la scroll jos, arata la scroll sus
	//   scroll_sticky → sticky permanent, doar umbra la scroll (nu se ascunde)
	(function() {
		var header = document.getElementById('site-header');
		if ( ! header ) return;

		var behavior = header.getAttribute('data-header-behavior') || 'scroll_normal';
		if ( behavior === 'scroll_normal' ) return;

		var lastScrollY = 0;
		var ticking    = false;

		function updateHeader() {
			var currentY = window.scrollY;
			if ( behavior === 'scroll_hide' ) {
				if ( currentY > lastScrollY && currentY > 80 ) {
					header.classList.add('Header--hidden');
				} else {
					header.classList.remove('Header--hidden');
				}
			}
			header.classList.toggle('Header--scrolled', currentY > 4);
			lastScrollY = currentY;
			ticking = false;
		}

		window.addEventListener('scroll', function() {
			if ( ! ticking ) {
				window.requestAnimationFrame( updateHeader );
				ticking = true;
			}
		}, { passive: true });
	})();

	// Mobile overlay — deschide / închide
	(function() {
		var toggle   = document.querySelector('.Header__MobileToggle');
		var overlay  = document.querySelector('.Header__MobileOverlay');
		var closeBtn = document.querySelector('.Header__MobileClose');
		if ( ! toggle || ! overlay ) return;

		function openMenu() {
			overlay.classList.add('is-open');
			overlay.setAttribute('aria-hidden', 'false');
			toggle.setAttribute('aria-expanded', 'true');
			document.body.style.overflow = 'hidden';
		}
		function closeMenu() {
			overlay.classList.remove('is-open');
			overlay.setAttribute('aria-hidden', 'true');
			toggle.setAttribute('aria-expanded', 'false');
			document.body.style.overflow = '';
		}

		toggle.addEventListener('click', openMenu);
		if ( closeBtn ) closeBtn.addEventListener('click', closeMenu);

		document.addEventListener('keydown', function( e ) {
			if ( e.key === 'Escape' && overlay.classList.contains('is-open') ) closeMenu();
		});
		window.addEventListener('resize', function() {
			if ( window.innerWidth >= 992 && overlay.classList.contains('is-open') ) closeMenu();
		});

		// Accordion doar pe nivel 1 — sub-grupurile rămân deschise, fără toggle.
		// Deschide submeniul atât la click pe săgeată, cât și pe link-ul părinte.
		overlay.querySelectorAll('.Header__MobileNav > .menu-item-has-children').forEach(function( li ) {
			var btn     = document.createElement('button');
			btn.className = 'Header__MobileSubToggle';
			btn.setAttribute('aria-expanded', 'false');
			btn.setAttribute('aria-label', 'Expandează submeniu');
			var subMenu = li.querySelector('.sub-menu');
			if ( subMenu ) li.insertBefore( btn, subMenu );

			function toggleSub() {
				var isOpen = li.classList.toggle('is-open');
				btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			}

			btn.addEventListener('click', toggleSub);

			// Click pe link-ul părinte (item cu copii) deschide submeniul în loc să navigheze
			var link = li.querySelector(':scope > a');
			if ( link ) {
				link.addEventListener('click', function( e ) {
					e.preventDefault();
					toggleSub();
				});
			}
		});
	})();

	// „Dezactivare Pagină" — link-uri de meniu care nu navighează (marcate din PHP
	// cu data-evx-no-link, vezi inc/menu-fields.php). Dropdown-ul rămâne funcțional:
	// hover pe desktop, toggle pe mobil (handler-ul de mai sus se ocupă de toggle).
	(function() {
		document.querySelectorAll('.Header__Nav a[data-evx-no-link], .Header__MobileOverlay a[data-evx-no-link]').forEach(function( link ) {
			link.addEventListener('click', function( e ) {
				e.preventDefault();
			});
		});
	})();

	// Priority nav — itemele care nu încap în meniul desktop se mută într-un dropdown
	// „Mai multe" (recalculat la resize/load). Scalarea fluidă (CSS) strânge itemele;
	// asta preia restul, ca meniul să arate bine pe orice rezoluție de desktop.
	(function() {
		var nav = document.querySelector('.Header__Nav');
		if (!nav) { return; }
		var list = nav.querySelector('.Header__NavList');
		if (!list) { return; }

		var more = document.createElement('li');
		more.className = 'menu-item-has-children Header__NavMore';
		more.style.display = 'none';
		more.innerHTML = '<a href="#" aria-haspopup="true">Mai multe<i class="icon-chevron-down" aria-hidden="true"></i></a><ul class="sub-menu"></ul>';
		more.querySelector('a').addEventListener('click', function(e) { e.preventDefault(); });
		list.appendChild(more);
		var moreMenu = more.querySelector('.sub-menu');

		function layout() {
			// 1. Restaurează itemele mutate înapoi în listă (înainte de „Mai multe").
			while (moreMenu.firstElementChild) {
				list.insertBefore(moreMenu.firstElementChild, more);
			}
			more.style.display = 'none';

			// Nav ascuns (mobil) → nimic de calculat.
			if (!nav.offsetWidth) { return; }

			var items = Array.prototype.filter.call(list.children, function(li) { return li !== more; });
			var total = items.reduce(function(s, li) { return s + li.offsetWidth; }, 0);
			if (total <= nav.clientWidth) { return; } // încap toate

			// 2. Arată „Mai multe" și mută iteme de la coadă până când restul încape.
			more.style.display = '';
			var avail = nav.clientWidth - more.offsetWidth;
			var i = items.length - 1;
			while (i >= 0 && total > avail) {
				total -= items[i].offsetWidth;
				moreMenu.insertBefore(items[i], moreMenu.firstChild);
				i--;
			}
			if (!moreMenu.children.length) { more.style.display = 'none'; }
		}

		layout();
		var t;
		window.addEventListener('resize', function() { clearTimeout(t); t = setTimeout(layout, 150); });
		window.addEventListener('load', layout);
	})();

	// Search — toggle
	$('.Header__SearchToggle').click(function() {
		var open = $('#header-search-area').toggleClass('is-active').hasClass('is-active');
		$(this).toggleClass('is-active', open).attr('aria-expanded', open ? 'true' : 'false');
		if ( open ) $('#header-search-input').focus();
	});

	// Search AJAX — live results dropdown
	(function() {
		const $input    = $('#header-search-input');
		const $dropdown = $('#search-dropdown');
		if ( ! $input.length ) return;

		let searchTimer = null;
		let lastQuery   = '';

		function closeDropdown() {
			$dropdown.removeClass('is-open').empty();
		}

		function doSearch( query ) {
			if ( query === lastQuery ) return;
			lastQuery = query;

			if ( query.length < 2 ) {
				closeDropdown();
				return;
			}

			$dropdown.addClass('is-open').html('<div class="search-dropdown__loader">Se caută...</div>');

			$.ajax({
				type: 'post',
				url:  window.global.ajaxurl,
				data: {
					action: 'evx_search',
					nonce:  window.global.nonce,
					query:  query,
				},
				success: function( response ) {
					if ( response && response.trim() ) {
						$dropdown.addClass('is-open').html( response );
					} else {
						closeDropdown();
					}
				},
				error: function() { closeDropdown(); }
			});
		}

		$input.on('input', function() {
			clearTimeout( searchTimer );
			const query = $(this).val().trim();
			searchTimer = setTimeout( function() { doSearch( query ); }, 320 );
		});

		// Inchide la click afara
		$(document).on('click', function(e) {
			if ( ! $(e.target).closest('.Header__Search').length ) {
				closeDropdown();
				lastQuery = '';
			}
		});

		// Inchide la Escape
		$input.on('keydown', function(e) {
			if ( e.key === 'Escape' ) { closeDropdown(); lastQuery = ''; }
		});
	})();

	// Search results page — filtru sidebar (tip) + paginatie numerotata prin AJAX
	(function() {
		var page = document.querySelector('.search-page');
		if ( ! page ) return;
		var results    = page.querySelector('#search-results');
		var filterBox  = page.querySelector('.search-page__filterBox');
		if ( ! results ) return;

		function setActiveTab( tip ) {
			if ( ! filterBox ) return;
			filterBox.querySelectorAll('.search-page__filterOption').forEach(function( a ) {
				var atip = new URL( a.href, window.location.origin ).searchParams.get('tip') || 'all';
				a.classList.toggle('is-active', atip === tip);
			});
		}

		function load( href, push ) {
			var url    = new URL( href, window.location.origin );
			var params = url.searchParams;
			var tip    = params.get('tip') || 'all';

			results.classList.add('is-loading');

			$.ajax({
				type: 'get',
				url:  window.global.ajaxurl,
				data: {
					action: 'evx_search_page',
					nonce:  window.global.nonce,
					query:  params.get('s') || '',
					tip:    tip,
					pagina: params.get('pagina') || 1
				},
				success: function( html ) {
					results.innerHTML = html;
					setActiveTab( tip );
					if ( push ) history.pushState( { evxSearch: true }, '', url.href );
					results.scrollIntoView({ behavior: 'smooth', block: 'start' });
				},
				complete: function() { results.classList.remove('is-loading'); }
			});
		}

		// Interceptare click pe optiunile de filtru si numerele de pagina (link-uri reale = fallback no-JS)
		page.addEventListener('click', function( e ) {
			var a = e.target.closest('.search-page__filterOption, .search-page__page');
			if ( ! a || ! page.contains( a ) ) return;
			e.preventDefault();
			load( a.href, true );
		});

		// Back/forward din browser
		window.addEventListener('popstate', function() {
			if ( document.querySelector('.search-page') ) load( window.location.href, false );
		});
	})();

	// Menu — highlight item curent
	document.querySelectorAll(
		'.Header__NavList .current-menu-item, .Header__NavList .current-menu-parent,' +
		'.Header__MobileNav .current-menu-item, .Header__MobileNav .current-menu-parent'
	).forEach(function( el ) { el.classList.add('is-current'); });

	// CF7 — GTM form submit event
	$(document).on('wpcf7mailsent', function() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ 'event': 'form-submit' });
	});

	// Back to top
	$(window).scroll(function() {
		if ( $(this).scrollTop() > 600 ) {
			$scrollTop.addClass('is-visible');
		} else {
			$scrollTop.removeClass('is-visible');
		}
	});
	$scrollTop.on('click', function() {
		$html.animate({ scrollTop: 0 }, 1000);
	});

	// Bootstrap tooltips (BS5: data-bs-toggle)
	$('[data-bs-toggle="tooltip"]').tooltip();

	// Icon Grid — hover pe item activează pin-ul corespunzător de pe imagine + tooltip
	$('.CelcoIconGrid').each(function() {
		const $grid = $(this);
		function pinFor(idx) { return $grid.find('.CelcoIconGrid__pin[data-index="' + idx + '"]'); }
		$grid.find('.CelcoIconGrid__item')
			.on('mouseenter', function() {
				const $pin = pinFor($(this).data('index'));
				$pin.addClass('is-active');
				if ( window.bootstrap && bootstrap.Tooltip && $pin[0] ) {
					bootstrap.Tooltip.getOrCreateInstance($pin[0]).show();
				}
			})
			.on('mouseleave', function() {
				const $pin = pinFor($(this).data('index'));
				$pin.removeClass('is-active');
				if ( window.bootstrap && bootstrap.Tooltip && $pin[0] ) {
					const inst = bootstrap.Tooltip.getInstance($pin[0]);
					if ( inst ) inst.hide();
				}
			});
	});

	// ── Legacy Hero Slideshow ─────────────────────────────────────────────────
	(function() {
		function initLegacyHero() {
			$('.LegacyHero__Slider').each(function() {
				var $slider      = $(this);
				if ( $slider.hasClass('slick-initialized') ) return;
				var autoplayMs = parseInt( $slider.find('.LegacyHero__Item').first().data('autoplay') ) || 6000;

				$slider.slick({
					arrows:        false,
					dots:          false,
					infinite:      true,
					autoplay:      true,
					autoplaySpeed: autoplayMs,
					speed:         800,
					fade:          true,
					cssEase:       'cubic-bezier(.44,0,.56,1)',
					pauseOnHover:  false,
				});

				$slider.on( 'afterChange', function( e, slick, current ) {
					var hero = $slider.closest('.LegacyHero');
					hero.find('.LegacyHero__Dot').removeClass('is-active');
					hero.find('.LegacyHero__Dot[data-index="' + current + '"]').addClass('is-active');
				});
			});
		}

		initLegacyHero();

		// Dots — click
		$(document).on( 'click', '.LegacyHero__Dot', function() {
			var $dot    = $(this);
			var $slider = $dot.closest('.LegacyHero').find('.LegacyHero__Slider');
			$slider.slick( 'slickGoTo', parseInt( $dot.data('index') ) );
		});
	})();

	// ── Hero: video YouTube de fundal via IFrame API ──────────────────────────
	// Autoplay fiabil pe mobil (mute + playsinline + playVideo programatic) și
	// loop SEAMLESS (seekTo(0) la ENDED, în loc de reload → fără cadre negre).
	(function() {
		var frames  = document.querySelectorAll('.LegacyHero__YT');
		if ( ! frames.length ) return;
		var players = [];

		function playAll() {
			players.forEach(function( p ) {
				if ( p && typeof p.playVideo === 'function' ) { p.mute(); p.playVideo(); }
			});
		}

		function initPlayers() {
			frames.forEach(function( frame ) {
				if ( ! frame.id || frame.dataset.ytInit ) return;
				frame.dataset.ytInit = '1';
				/* global YT */
				var player = new YT.Player( frame.id, {
					events: {
						onReady: function( e ) {
							e.target.mute();
							// Dezactivează subtitrarea (CC pornit implicit din contul userului):
							// scoate modulul de subtitrări indiferent de setarea YouTube.
							try { e.target.unloadModule('captions'); e.target.unloadModule('cc'); } catch ( err ) {}
							e.target.playVideo();
						},
						onStateChange: function( e ) {
							// PLAYING (1) → clipul rulează: ascunde stratul de acoperire
							// (maschează butonul play/pause YouTube de la încărcare).
							if ( e.data === YT.PlayerState.PLAYING ) {
								var iframe = e.target.getIframe();
								var media  = iframe && iframe.closest('.LegacyHero__Media');
								var cover  = media && media.querySelector('.LegacyHero__YTCover');
								if ( cover ) cover.classList.add('is-hidden');
									// Clipul rulează → modulul de subtitrări e disponibil acum:
									// îl scoatem fiabil (onReady era prea devreme).
									try {
										e.target.unloadModule('captions');
										e.target.unloadModule('cc');
										e.target.setOption('captions', 'track', {});
										e.target.setOption('cc', 'track', {});
									} catch ( err ) {}
							}
							// ENDED (0) → reia de la început fără flash negru de reîncărcare
							if ( e.data === YT.PlayerState.ENDED ) {
								e.target.seekTo( 0 );
								e.target.playVideo();
							}
						}
					}
				});
				players.push( player );

				// Siguranță: dacă PLAYING nu se declanșează (API blocat etc.), tot ridicăm
				// stratul de acoperire după câteva secunde ca să nu rămână box-ul peste hero.
				var media = frame.closest('.LegacyHero__Media');
				var cover = media && media.querySelector('.LegacyHero__YTCover');
				if ( cover ) {
					setTimeout(function() { cover.classList.add('is-hidden'); }, 4000);
				}
			});

			// Fallback: unele browsere mobile cer un gest înainte de redare → pornim
			// la prima atingere/scroll (o singură dată).
			[ 'touchstart', 'scroll', 'click' ].forEach(function( ev ) {
				window.addEventListener( ev, function once() {
					playAll();
					[ 'touchstart', 'scroll', 'click' ].forEach(function( e2 ) {
						window.removeEventListener( e2, once );
					});
				}, { passive: true, once: true } );
			});
		}

		// Încarcă API-ul YouTube o singură dată (păstrează un eventual callback existent)
		if ( window.YT && window.YT.Player ) {
			initPlayers();
		} else {
			var prev = window.onYouTubeIframeAPIReady;
			window.onYouTubeIframeAPIReady = function() {
				if ( typeof prev === 'function' ) prev();
				initPlayers();
			};
			if ( ! document.querySelector('script[src*="youtube.com/iframe_api"]') ) {
				var tag = document.createElement('script');
				tag.src = 'https://www.youtube.com/iframe_api';
				document.head.appendChild( tag );
			}
		}
	})();

	// Celco Categorii Produse — slideshow (slick) DOAR pe mobil (≤768px); grid pe desktop.
	(function() {
		var grids = $('.CategoriiProduse__grid');
		if ( ! grids.length || ! ($.fn && $.fn.slick) ) return;

		var mq = window.matchMedia('(max-width: 767.98px)');

		function apply() {
			grids.each(function() {
				var $g = $(this);
				if ( mq.matches ) {
					if ( ! $g.hasClass('slick-initialized') ) {
						$g.slick({
							slidesToShow:   1,
							slidesToScroll: 1,
							arrows:         false,
							dots:           true,
							infinite:       false,
							adaptiveHeight: true,
						});
					}
				} else if ( $g.hasClass('slick-initialized') ) {
					$g.slick('unslick');
				}
			});
		}

		apply();
		mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
	})();

	// Celco Grid Produse — slideshow (slick) DOAR pe mobil (≤768px).
	// Butonul „toată gama" (.GridProduse__more) stă permanent jos, centrat (markup).
	(function() {
		var sections = $('.GridProduse');
		if ( ! sections.length || ! ($.fn && $.fn.slick) ) return;

		var mq = window.matchMedia('(max-width: 767.98px)');

		function apply() {
			sections.each(function() {
				var $section = $(this);
				var $cards = $section.find('.GridProduse__cards');

				if ( mq.matches ) {
					if ( $cards.length && ! $cards.hasClass('slick-initialized') ) {
						$cards.slick({
							slidesToShow:   1,
							slidesToScroll: 1,
							arrows:         false,
							dots:           true,
							infinite:       false,
							adaptiveHeight: true,
						});
					}
				} else {
					if ( $cards.hasClass('slick-initialized') ) $cards.slick('unslick');
				}
			});
		}

		apply();
		mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
	})();

	// Celco Redare Postari — mod grid devine slideshow (slick) pe mobil + tabletă (≤1024px):
	// 2 carduri pe tabletă (≥576px), 1 card pe telefon (<576px).
	(function() {
		var grids = $('.CelcoPosts__grid');
		if ( ! grids.length || ! ($.fn && $.fn.slick) ) return;

		var mq = window.matchMedia('(max-width: 1023.98px)');

		function apply() {
			grids.each(function() {
				var $g = $(this);
				if ( mq.matches ) {
					if ( ! $g.hasClass('slick-initialized') ) {
						$g.slick({
							slidesToShow:   2,
							slidesToScroll: 2,
							arrows:         false,
							dots:           true,
							infinite:       false,
							adaptiveHeight: true,
							responsive: [
								{ breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
							],
						});
					}
				} else if ( $g.hasClass('slick-initialized') ) {
					$g.slick('unslick');
				}
			});
		}

		apply();
		mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
	})();

	// Smooth scroll la anchor links (exclude BS5 tab/collapse triggers)
	$(document).on('click', 'a[href^="#"]', function(event) {
		const bsToggle = $(this).attr('data-bs-toggle');
		const toggle   = $(this).attr('data-toggle');

		if ( bsToggle === 'tab' || bsToggle === 'collapse' || toggle === 'tab' || toggle === 'collapse' ) {
			return;
		}

		if ( $(this).hasClass('ProductTabs__menuItem') ) {
			return;
		}

		const href = $(this).attr('href');

		if ( !href || href === '#' || !$(href).length ) {
			return;
		}

		event.preventDefault();
		$('html, body').animate({
			scrollTop: $(href).offset().top - 60
		}, 1000);
	});

	// File upload — label update
	$('.custom-file-input').on('change', function() {
		const fileName = $(this).val().split('\\').pop();
		$(this).parent().siblings('.custom-file-label').addClass('selected').html(fileName);
	});

	// GDPR — disable/enable form fields
	$('.gdpr-form-container').find('input, textarea, select').prop('disabled', true);
	$('#gdpr-notice').prop('checked', false).on('change', function() {
		$('.gdpr-form-container').toggleClass('is-active');
		$('.gdpr-form-container').find('input, textarea, select').prop('disabled', !this.checked);
	});

	// Sidebar category — toggle pe mobile
	$('.Sidebar__categories h4').click(function() {
		$('.Sidebar__categories .content_bg').toggleClass('active');
	});

	// CF7 switch custom
	$('#customSwitch1 input').attr('class', 'custom-control-input').attr('id', 'SwitchIn');
	$('.wpcf7-list-item-label').addClass('d-none');

	// ─── Animații ─────────────────────────────────────────────────────────────

	// Illustration inview animation — IntersectionObserver nativ (inlocuieste jquery.inview)
	const illustrationObserver = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				// TOATE imaginile primesc is-animated (fiecare are propria animatie),
				// nu doar prima — altfel se anima 1 singura imagine, restul ramaneau opacity:0.
				entry.target.querySelectorAll('.var-illustration__img').forEach(function(img) {
					img.classList.add('is-animated');
				});
				illustrationObserver.unobserve(entry.target);
			}
		});
	}, { threshold: 0.1 });

	document.querySelectorAll('.var-illustration').forEach(function(el) {
		illustrationObserver.observe(el);
	});

	// ─── Sliders ──────────────────────────────────────────────────────────────

	// General carousel — data-attribute driven, folosit pe mai multe pagini
	$('.general-carousel').each(function() {
		const $carousel = $(this);
		$carousel.slick({
			dots:           $carousel.data('dots')            !== undefined ? $carousel.data('dots')            : true,
			arrows:         $carousel.data('arrows')          !== undefined ? $carousel.data('arrows')          : false,
			infinite:       true,
			speed:          400,
			slidesToShow:   $carousel.data('slides-to-show')  !== undefined ? $carousel.data('slides-to-show')  : 1,
			slidesToScroll: $carousel.data('slides-to-scroll') !== undefined ? $carousel.data('slides-to-scroll') : 1,
			adaptiveHeight: $carousel.data('adaptive-height') !== undefined ? $carousel.data('adaptive-height') : false,
			nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-right-open-mini"></i></button>',
			prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-left-open-mini"></i></button>',
			responsive: [
				{ breakpoint: 1440, settings: { adaptiveHeight: true } },
				{ breakpoint: 576,  settings: { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: true } }
			]
		});
	});

	// Hero slideshow (Elementor widget)
	if ( $('.Slider').length ) {
		$('.Slider').slick({
			centerMode:    true,
			centerPadding: '0px',
			slidesToShow:  1,
			autoplay:      true,
			autoplaySpeed: 2500,
			infinite:      false,
			dots:          false,
			appendArrows:  '.sln',
			nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-mini"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-mini"></i></button>',
		});
	}

	// Fabrici carousel
	if ( $('.Fabrici__carousel').length ) {
		$('.Fabrici__carousel').slick({
			dots:           false,
			arrows:         true,
			infinite:       true,
			speed:          300,
			slidesToShow:   3,
			slidesToScroll: 1,
			nextArrow: '<button type="button" class="slick-next"><i class="icon-next fz-32"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="icon-prew fz-32"></i></button>',
			responsive: [
				{ breakpoint: 1024, settings: { slidesToShow: 2 } },
				{ breakpoint: 576,  settings: { slidesToShow: 1 } }
			]
		});
	}

	// Fabrici gallery (pagina fabrici)
	if ( $('.Fabrici__Galery').length ) {
		$('.Fabrici__Galery').slick({
			centerMode:    true,
			centerPadding: '0px',
			slidesToShow:  1,
			dots:          false,
			nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-right-open-mini"></i></button>',
			prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-left-open-mini"></i></button>',
			responsive: [
				{ breakpoint: 700, settings: { slidesToShow: 1, dots: false } }
			]
		});
	}

	// Proiecte slider (Elementor widget)
	if ( $('.Proiecte__Slider').length ) {
		$('.Proiecte__Slider').slick({
			centerMode:     false,
			centerPadding:  '0px',
			slidesToShow:   3,
			infinite:       false,
			dots:           false,
			nextArrow: '<button type="button" class="slick-next"><i class="icon-next fz-32"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="icon-prew fz-32"></i></button>',
			responsive: [
				{ breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
				{ breakpoint: 576,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
			]
		});
	}

	// Proiect carousel (pagina single proiect)
	if ( $('.proiect-carousel').length ) {
		$('.proiect-carousel').slick({
			centerMode:    true,
			centerPadding: '0px',
			slidesToShow:  1,
			dots:          false,
			nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-right-open-mini"></i></button>',
			prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-left-open-mini"></i></button>',
			responsive: [
				{ breakpoint: 700, settings: { slidesToShow: 1, dots: false } }
			]
		});
	}

	// Products carousel
	if ( $('.products-carousel').length ) {
		$('.products-carousel').slick({
			dots:           false,
			arrows:         true,
			infinite:       false,
			speed:          300,
			slidesToShow:   3,
			slidesToScroll: 1,
			nextArrow: '<button type="button" class="slick-next"><i class="icon-next fz-32"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="icon-prew fz-32"></i></button>',
			responsive: [
				{ breakpoint: 1024, settings: { slidesToShow: 2 } },
				{ breakpoint: 576,  settings: { slidesToShow: 1 } }
			]
		});
	}

	// Articole carousel
	if ( $('.Articole__carousel').length ) {
		$('.Articole__carousel').slick({
			dots:           false,
			arrows:         true,
			infinite:       true,
			speed:          300,
			slidesToShow:   3,
			slidesToScroll: 1,
			nextArrow: '<button type="button" class="slick-next"><i class="icon-next fz-32"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="icon-prew fz-32"></i></button>',
			responsive: [
				{ breakpoint: 1024, settings: { slidesToShow: 2 } },
				{ breakpoint: 576,  settings: { slidesToShow: 1 } }
			]
		});
	}

	// Activitati gallery
	if ( $('.Activitati__Galerie').length ) {
		$('.Activitati__Galerie').slick({
			centerMode:    true,
			centerPadding: '0px',
			slidesToShow:  1,
			dots:          true,
			prevArrow:     false,
			nextArrow:     false,
		});
	}

	// Activitati gallery — mobile only
	if ( $('.Activitati__Galerie--Mobile').length && $(window).width() < 570 ) {
		$('.Activitati__Galerie--Mobile').slick({
			arrows:        true,
			dots:          false,
			centerMode:    true,
			centerPadding: '0px',
			slidesToShow:  1,
			nextArrow: '<i class="icon-next fz-32 slick-arrow slick-next"></i>',
			prevArrow: '<i class="icon-prew fz-32 slick-arrow slick-prev"></i>',
		});
	}

	// Single Job gallery
	if ( $('.Single-Job__Galery').length ) {
		$('.Single-Job__Galery').slick({
			centerMode:    true,
			centerPadding: '0px',
			slidesToShow:  1,
			dots:          true,
			prevArrow:     false,
			nextArrow:     false,
		});
	}

	// Cum se fabrica carousel
	if ( $('.cum-se-fabrica-carousel').length ) {
		$('.cum-se-fabrica-carousel').slick({
			dots:           false,
			arrows:         true,
			infinite:       true,
			speed:          300,
			slidesToShow:   3,
			slidesToScroll: 1,
			nextArrow: '<button type="button" class="slick-next"><i class="icon-next fz-32"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="icon-prew fz-32"></i></button>',
			responsive: [
				{ breakpoint: 1024, settings: { slidesToShow: 2 } },
				{ breakpoint: 576,  settings: { slidesToShow: 1 } }
			]
		});
	}

	// Single product — caruseluri din josul paginii (other + recent)
	// Defer dupa primul frame pentru a nu bloca randarea initiala
	if ( $('.other-products-carousel').length || $('.recent-products-carousel').length ) {
		requestAnimationFrame(function() {
			setTimeout(function() {
				if ( $('.other-products-carousel').length ) {
					$('.other-products-carousel').slick({
						dots:           false,
						infinite:       true,
						speed:          300,
						slidesToShow:   5,
						slidesToScroll: 1,
						prevArrow: '<i class="icon-arrow-left fz-20"></i>',
						nextArrow: '<i class="icon-arrow-right fz-20"></i>',
						responsive: [
							{ breakpoint: 1200, settings: { slidesToShow: 4 } },
							{ breakpoint: 768,  settings: { slidesToShow: 3 } },
							{ breakpoint: 576,  settings: { slidesToShow: 2 } }
						]
					});
				}
				if ( $('.recent-products-carousel').length ) {
					$('.recent-products-carousel').slick({
						dots:           false,
						infinite:       false,
						speed:          300,
						slidesToShow:   4,
						slidesToScroll: 1,
						prevArrow: '<i class="icon-arrow-left fz-20"></i>',
						nextArrow: '<i class="icon-arrow-right fz-20"></i>',
						responsive: [
							{ breakpoint: 768, settings: { slidesToShow: 3 } },
							{ breakpoint: 576, settings: { slidesToShow: 2 } }
						]
					});
				}
			}, 0);
		});
	}

	// Distribuitori locatii slider + map + select sync
	const $distribuitoriLocatii = $('.distribuitori__locatii');
	if ( $distribuitoriLocatii.length ) {
		const $startslider = $('option:selected', this).attr('data-distribuitor-id');
		$distribuitoriLocatii.slick({
			dots:           false,
			infinite:       false,
			adaptiveHeight: true,
			speed:          0,
			slidesToShow:   2,
			slidesToScroll: 1,
			initialSlide:   parseInt($startslider),
			prevArrow: '<i class="icon-arrow-left fz-20"></i>',
			nextArrow: '<i class="icon-arrow-right fz-20"></i>',
			responsive: [
				{ breakpoint: 1200, settings: { slidesToShow: 1, slidesToScroll: 1 } },
				{ breakpoint: 768,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
				{ breakpoint: 576,  settings: { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: true } }
			]
		});

		$distribuitoriLocatii.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			const county         = $distribuitoriLocatii.find('[data-slick-index=' + nextSlide + ']').attr('data-county');
			const distribuitorID = $distribuitoriLocatii.find('[data-slick-index=' + nextSlide + ']').attr('data-distribuitor-id');
			$('.distribuitori__map').find('.distribuitori__map-pin').removeClass('is-active');
			$('.distribuitori__map').find('.distribuitori__map-pin[data-county=' + county + ']').addClass('is-active');
			$('.distribuitori__select').find('option[data-distribuitor-id="' + distribuitorID + '"]').prop('selected', true);
		});

		$('.distribuitori__map-pin').on('click', function() {
			if ( $(this).hasClass('is-active') ) return;
			const county         = $(this).attr('data-county');
			const nextSlideIndex = $distribuitoriLocatii.find('[data-county=' + county + ']').eq(0).attr('data-slick-index');
			$distribuitoriLocatii.slick('slickGoTo', nextSlideIndex);
		});

		$('.distribuitori__select').change(function() {
			const distribuitorID = $(this).find('option:selected').attr('data-distribuitor-id');
			const nextSlideIndex = $distribuitoriLocatii.find('[data-distribuitor-id=' + distribuitorID + ']').attr('data-slick-index');
			$distribuitoriLocatii.slick('slickGoTo', nextSlideIndex);
		});

		const mapEl = document.querySelector('.distribuitori__map');
		if (mapEl) {
			const mapObserver = new IntersectionObserver(function(entries) {
				if (entries[0].isIntersecting) {
					document.querySelectorAll('.distribuitori__map-pin').forEach(function(pin) {
						pin.classList.add('is-animated');
					});
					mapObserver.disconnect();
				}
			}, { threshold: 0.1 });
			mapObserver.observe(mapEl);
		}
	}

	// Filtru județ reutilizabil (buton-icon + popup checkbox-uri, multi-select).
	// Întoarce null dacă widget-ul nu are filtru; altfel { getSelected, toggleCounty, clear }.
	function wireCountyFilter($w, onChange) {
		const $filter = $w.find('.DistribuitoriFilter');
		if (!$filter.length) { return null; }
		const $toggle = $filter.find('.DistribuitoriFilter__toggle');
		const $pop    = $filter.find('.DistribuitoriFilter__pop');
		const $cbs    = $filter.find('.DistribuitoriFilter__cb');
		const $badge  = $filter.find('.DistribuitoriFilter__count');

		function getSelected() {
			return $cbs.filter(':checked').map(function() { return $(this).val(); }).get();
		}
		function refresh() {
			const n = getSelected().length;
			if (n > 0) { $badge.text(n).prop('hidden', false); $toggle.addClass('is-active'); }
			else { $badge.prop('hidden', true); $toggle.removeClass('is-active'); }
		}
		function close() { $pop.prop('hidden', true); $toggle.attr('aria-expanded', 'false'); }

		$toggle.on('click', function(e) {
			e.stopPropagation();
			const willOpen = $pop.prop('hidden');
			$pop.prop('hidden', !willOpen);
			$toggle.attr('aria-expanded', willOpen ? 'true' : 'false');
		});
		$pop.on('click', function(e) { e.stopPropagation(); });
		$(document).on('click', close);
		$cbs.on('change', function() { refresh(); onChange(); });
		$filter.find('.DistribuitoriFilter__clear').on('click', function() {
			$cbs.prop('checked', false); refresh(); onChange();
		});

		refresh();
		return {
			getSelected: getSelected,
			toggleCounty: function(county) {
				const $cb = $cbs.filter(function() { return $(this).val() === county; });
				$cb.prop('checked', !$cb.prop('checked'));
				refresh();
			},
			clear: function() { $cbs.prop('checked', false); refresh(); }
		};
	}

	// Distribuitori New (A hartă / B grilă) — filtru județ (pin + popup checkbox) + căutare
	$('.DistribuitoriNew').not('.DistribuitoriNew--accordion').not('.DistribuitoriMap').each(function() {
		const $w      = $(this);
		const $cards  = $w.find('.DistribuitoriNew__card');
		const $pins   = $w.find('.distribuitori__map-pin');
		const $search = $w.find('.DistribuitoriNew__search');
		const $count  = $w.find('.DistribuitoriNew__count');
		const $empty  = $w.find('.DistribuitoriNew__empty');
		const $reset  = $w.find('.DistribuitoriNew__reset');
		let pinCounty = ''; // folosit doar când NU există popup de filtre (harta e filtrul)

		function norm(str) {
			return (str || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
		}

		const filter = wireCountyFilter($w, function() { apply(); });

		function selectedCounties() {
			if (filter) { return filter.getSelected(); }
			return pinCounty ? [pinCounty] : [];
		}

		function apply() {
			const nTerm = norm($search.val());
			const sel   = selectedCounties();
			const nSel  = sel.map(norm);
			let visible = 0;
			$cards.each(function() {
				const cc = norm($(this).attr('data-county'));
				const okCounty = !nSel.length || nSel.indexOf(cc) !== -1;
				const okTerm   = !nTerm || norm($(this).attr('data-search')).indexOf(nTerm) !== -1;
				const show = okCounty && okTerm;
				$(this).toggleClass('is-hidden', !show);
				if (show) { visible++; }
			});

			$count.text(visible + ' ' + (visible === 1 ? 'distribuitor' : 'distribuitori'));
			$empty.toggleClass('is-visible', visible === 0);

			$pins.removeClass('is-selected');
			sel.forEach(function(c) { $pins.filter('[data-county="' + c + '"]').addClass('is-selected'); });

			$reset.toggleClass('is-visible', !!$search.val() || sel.length > 0);
		}

		// Click pe pin (doar județele cu distribuitori) → (de)selectează județul.
		$pins.filter('.has-items').css('cursor', 'pointer').on('click', function() {
			const county = $(this).attr('data-county');
			if (filter) { filter.toggleCounty(county); }
			else { pinCounty = (pinCounty === county) ? '' : county; }
			apply();
		});

		$search.on('input', apply);

		$reset.on('click', function() {
			$search.val('');
			pinCounty = '';
			if (filter) { filter.clear(); }
			apply();
		});

		// Animație pin-uri la intrarea hărții în viewport (reutilizează keyframe-ul legacy).
		const mapEl = $w.find('.distribuitori__map')[0];
		if (mapEl) {
			const obs = new IntersectionObserver(function(entries) {
				if (entries[0].isIntersecting) {
					$pins.addClass('is-animated');
					obs.disconnect();
				}
			}, { threshold: 0.1 });
			obs.observe(mapEl);
		}

		apply();
	});

	// Distribuitori New (C accordion) — județe pliabile + căutare globală
	$('.DistribuitoriNew--accordion').each(function() {
		const $w      = $(this);
		const $groups = $w.find('.DistribuitoriAcc__group');
		const $search = $w.find('.DistribuitoriNew__search');
		const $count  = $w.find('.DistribuitoriNew__count');
		const $empty  = $w.find('.DistribuitoriNew__empty');

		function norm(str) {
			return (str || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
		}

		const filter = wireCountyFilter($w, function() { apply(); });

		// Toggle grup
		$groups.find('.DistribuitoriAcc__head').on('click', function() {
			const $g = $(this).closest('.DistribuitoriAcc__group');
			const open = $g.toggleClass('is-open').hasClass('is-open');
			$(this).attr('aria-expanded', open ? 'true' : 'false');
		});

		function apply() {
			const nTerm = norm($search.val());
			const nSel  = ( filter ? filter.getSelected() : [] ).map(norm);
			let visible = 0;
			$groups.each(function() {
				const $g = $(this);
				const countyOk = !nSel.length || nSel.indexOf(norm($g.attr('data-county'))) !== -1;
				let gVisible = 0;
				if (countyOk) {
					$g.find('.DistribuitoriNew__card').each(function() {
						const show = !nTerm || norm($(this).attr('data-search')).indexOf(nTerm) !== -1;
						$(this).toggleClass('is-hidden', !show);
						if (show) { gVisible++; }
					});
				}
				$g.toggleClass('is-hidden', !countyOk || gVisible === 0);
				if ((nTerm || nSel.length) && gVisible > 0) {
					$g.addClass('is-open');
					$g.find('.DistribuitoriAcc__head').attr('aria-expanded', 'true');
				}
				visible += gVisible;
			});
			$count.text(visible + ' ' + (visible === 1 ? 'distribuitor' : 'distribuitori'));
			$empty.toggleClass('is-visible', visible === 0);
		}

		$search.on('input', apply);
		apply();
	});

	// Distribuitori New (D hartă reală) — Leaflet/OSM sau Google Maps + listă sincronizată
	$('.DistribuitoriMap').each(function() {
		const $w       = $(this);
		const provider = $w.attr('data-provider') || 'leaflet';
		const $canvas  = $w.find('.DistribuitoriMap__canvas');
		const $cards   = $w.find('.DistribuitoriMap__list .DistribuitoriNew__card');
		const $search  = $w.find('.DistribuitoriNew__search');
		const $count   = $w.find('.DistribuitoriNew__count');
		const $empty   = $w.find('.DistribuitoriNew__empty');
		const $reset   = $w.find('.DistribuitoriNew__reset');
		const $locate  = $w.find('.DistribuitoriMap__locate');

		function norm(str) {
			return (str || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
		}
		function esc(str) {
			return $('<div>').text(str || '').html();
		}

		// Puncte din cardurile cu coordonate valide.
		const points = [];
		$cards.each(function() {
			const lat = parseFloat($(this).attr('data-lat'));
			const lng = parseFloat($(this).attr('data-lng'));
			if (!isNaN(lat) && !isNaN(lng)) {
				points.push({
					$card: $(this),
					lat: lat,
					lng: lng,
					title: $.trim($(this).find('.DistribuitoriNew__name').text()),
					addr:  $.trim($(this).find('.DistribuitoriNew__meta li').first().text())
				});
			}
		});

		// Împrăștie în cerc markerii care cad exact pe același punct
		// (ex. distribuitorii geocodați pe centrul județului) ca să nu se suprapună.
		(function() {
			const groups = {};
			points.forEach(function(p) {
				const k = p.lat.toFixed(4) + ',' + p.lng.toFixed(4);
				(groups[k] = groups[k] || []).push(p);
			});
			Object.keys(groups).forEach(function(k) {
				const g = groups[k];
				if (g.length < 2) { return; }
				const R = 0.012;
				g.forEach(function(p, i) {
					const a = (2 * Math.PI * i) / g.length;
					p.lat += R * Math.cos(a);
					p.lng += R * Math.sin(a);
				});
			});
		})();

		let mapApi = null;

		function highlight(p) {
			$cards.removeClass('is-hl');
			p.$card.addClass('is-hl');
			if (p.$card[0].scrollIntoView) {
				p.$card[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		}

		const filter = wireCountyFilter($w, function() { applyFilter(); });

		function applyFilter() {
			const nTerm = norm($search.val());
			const nSel  = ( filter ? filter.getSelected() : [] ).map(norm);
			let visible = 0;
			$cards.each(function() {
				const okTerm   = !nTerm || norm($(this).attr('data-search')).indexOf(nTerm) !== -1;
				const okCounty = !nSel.length || nSel.indexOf(norm($(this).attr('data-county'))) !== -1;
				const show = okTerm && okCounty;
				$(this).toggleClass('is-hidden', !show);
				if (show) { visible++; }
			});
			const visPts = [];
			points.forEach(function(p) {
				const show = !p.$card.hasClass('is-hidden');
				if (mapApi) { mapApi.setVisible(p, show); }
				if (show) { visPts.push(p); }
			});
			$count.text(visible + ' ' + (visible === 1 ? 'distribuitor' : 'distribuitori'));
			$empty.toggleClass('is-visible', visible === 0);
			$reset.toggleClass('is-visible', !!$search.val() || nSel.length > 0);
			if (mapApi && visPts.length) { mapApi.fit(visPts); }
		}

		$search.on('input', applyFilter);
		$reset.on('click', function() { $search.val(''); if (filter) { filter.clear(); } applyFilter(); });

		$cards.on('click', function(e) {
			if ($(e.target).closest('a, button').length) { return; }
			const card = this;
			const p = points.filter(function(pp) { return pp.$card[0] === card; })[0];
			if (p && mapApi) { mapApi.panTo(p); highlight(p); }
		});

		function flashLocate(msg) {
			$w.find('.DistribuitoriMap__locateMsg').remove();
			$('<span class="DistribuitoriMap__locateMsg"></span>').text(msg).insertAfter($locate);
			setTimeout(function() {
				$w.find('.DistribuitoriMap__locateMsg').fadeOut(300, function() { $(this).remove(); });
			}, 2600);
		}

		$locate.on('click', function() {
			if (!mapApi) { return; }
			if (!navigator.geolocation) { flashLocate('Geolocalizare indisponibilă în acest browser'); return; }
			$locate.addClass('is-loading');
			navigator.geolocation.getCurrentPosition(function(pos) {
				$locate.removeClass('is-loading');
				const la = pos.coords.latitude, lo = pos.coords.longitude;
				let best = null, bestD = Infinity;
				points.forEach(function(p) {
					if (p.$card.hasClass('is-hidden')) { return; }
					const d = Math.pow(p.lat - la, 2) + Math.pow(p.lng - lo, 2);
					if (d < bestD) { bestD = d; best = p; }
				});
				if (best) { mapApi.panTo(best); highlight(best); }
			}, function(err) {
				$locate.removeClass('is-loading');
				flashLocate(err && err.code === 1 ? 'Permite accesul la locație pentru a folosi această opțiune' : 'Nu am putut obține locația');
			}, { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 });
		});

		function waitFor(test, cb, tries) {
			tries = (tries === undefined) ? 80 : tries;
			if (test()) { cb(); return; }
			if (tries <= 0) { return; }
			setTimeout(function() { waitFor(test, cb, tries - 1); }, 100);
		}

		function initLeaflet() {
			const map = L.map($canvas[0], { scrollWheelZoom: false }).setView([45.9, 25.0], 6);
			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; OpenStreetMap', maxZoom: 19
			}).addTo(map);

			points.forEach(function(p) {
				p.marker = L.marker([p.lat, p.lng]).addTo(map);
				p.marker.bindPopup('<strong>' + esc(p.title) + '</strong><br>' + esc(p.addr));
				p.marker.on('click', function() { highlight(p); });
			});

			mapApi = {
				setVisible: function(p, show) {
					if (show) { if (!map.hasLayer(p.marker)) { p.marker.addTo(map); } }
					else { if (map.hasLayer(p.marker)) { map.removeLayer(p.marker); } }
				},
				panTo: function(p) { map.setView([p.lat, p.lng], 12); p.marker.openPopup(); },
				fit: function(pts) {
					map.fitBounds(L.latLngBounds(pts.map(function(p) { return [p.lat, p.lng]; })), { padding: [30, 30], maxZoom: 12 });
				}
			};
			setTimeout(function() { map.invalidateSize(); applyFilter(); }, 200);
		}

		function initGoogle() {
			const map = new google.maps.Map($canvas[0], {
				center: { lat: 45.9, lng: 25.0 }, zoom: 6,
				mapTypeControl: false, streetViewControl: false, fullscreenControl: false
			});
			const info = new google.maps.InfoWindow();

			points.forEach(function(p) {
				p.marker = new google.maps.Marker({ position: { lat: p.lat, lng: p.lng }, map: map, title: p.title });
				p.marker.addListener('click', function() {
					info.setContent('<strong>' + esc(p.title) + '</strong><br>' + esc(p.addr));
					info.open(map, p.marker);
					highlight(p);
				});
			});

			mapApi = {
				setVisible: function(p, show) { p.marker.setMap(show ? map : null); },
				panTo: function(p) { map.panTo({ lat: p.lat, lng: p.lng }); map.setZoom(12); google.maps.event.trigger(p.marker, 'click'); },
				fit: function(pts) {
					const b = new google.maps.LatLngBounds();
					pts.forEach(function(p) { b.extend({ lat: p.lat, lng: p.lng }); });
					map.fitBounds(b);
				}
			};
			applyFilter();
		}

		if (!points.length) { applyFilter(); return; }

		if (provider === 'google') {
			waitFor(function() { return window.google && window.google.maps; }, initGoogle);
		} else {
			waitFor(function() { return window.L; }, initLeaflet);
		}
	});

	// ─── Componente ───────────────────────────────────────────────────────────

	// Pachet — class manipulation
	if ( $('.Pachet').length ) {
		$('.Pachet--Content a').addClass('btn btn-lg btn-green');
		$('.Pachet--Content ul li').addClass('col-12 col-md-6');
	}

	// Elements slideshow — h2 titlu
	if ( $('.elements_slideshow--content').length ) {
		$('.elements_slideshow--content h2').addClass('Titlu');
	}

	// Beneficii — pin & link hover sync
	if ( $('.Beneficii').length ) {
		$('.Beneficii__Links span').on('mouseenter click', function() {
			const icon = $(this).attr('data-icon');
			$('.Beneficii__Links span').removeClass('is-selected');
			$('.Beneficii__Links span[data-icon="' + icon + '"]').addClass('is-selected');
			$('.Beneficii__Pin').removeClass('is-selected');
			$('.Beneficii__Pin[data-icon="' + icon + '"]').addClass('is-selected');
		});

		$('.Beneficii__Pin').on('mouseenter click', function() {
			const icon = $(this).attr('data-icon');
			$('.Beneficii__Links span').removeClass('is-selected');
			$('.Beneficii__Links span[data-icon="' + icon + '"]').addClass('is-selected');
			$('.Beneficii__Pin').removeClass('is-selected');
			$('.Beneficii__Pin[data-icon="' + icon + '"]').addClass('is-selected');
		});
	}

	// Megaslideshow — sync icon-box cu general-carousel
	if ( $('.megaslideshow').length ) {
		$('.icon-box').on('click', function() {
			const $this = $(this);
			const index = $this.parent().index();
			if ( $this.hasClass('is-active') ) return;
			$this.parent().siblings().find('.icon-box').removeClass('is-active');
			$this.addClass('is-active');
			$this.parents('.section-row').find('.general-carousel').slick('slickGoTo', index);
		});

		$('.general-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			const $this = $(this);
			$this.parents('.section-row').find('.general-carousel').slick('slickGoTo', nextSlide);
			$this.parents('.section-row').find('.icon-box').removeClass('is-active').eq(nextSlide).addClass('is-active');
		});
	}

	// Text + Icon + Image Slideshow (nou) — sync carusele + iconițe + clamp/overlay
	$('.TextIconSlideshow').each(function() {
		const $w        = $(this);
		const $carousels = $w.find('.general-carousel');
		const $icons    = $w.find('.TextIconSlideshow__icon');

		function markClamp() {
			$w.find('.TextIconSlideshow__slide').each(function() {
				const $slide = $(this);
				const el = $slide.find('.TextIconSlideshow__content')[0];
				$slide.toggleClass('is-clamped', !!el && ( el.scrollHeight - el.clientHeight > 4 ));
			});
		}

		// sync: click pe iconiță -> ambele carusele
		$icons.on('click', function() {
			$carousels.slick('slickGoTo', $(this).data('index'));
		});

		// sync între carusele + iconița activă
		$carousels.on('beforeChange', function(e, slick, current, next) {
			$carousels.slick('slickGoTo', next);
			$icons.removeClass('is-active').eq(next).addClass('is-active');
		});

		// Clamp + overlay „citește mai mult" — doar când ReadMore e activat.
		// În mod --fulltext se afișează tot textul, fără buton/pop-up.
		if ( ! $w.hasClass('TextIconSlideshow--fulltext') ) {
			$carousels.on('setPosition', markClamp);

			// overlay: "citește mai mult" deschide, X închide
			$w.on('click', '.TextIconSlideshow__more', function() {
				const html = $(this).closest('.TextIconSlideshow__slide').find('.TextIconSlideshow__content').html();
				$w.find('.TextIconSlideshow__overlayInner').html(html);
				$w.addClass('is-overlay-open');
				$w.find('.TextIconSlideshow__overlay').attr('aria-hidden', 'false');
			});
			$w.on('click', '.TextIconSlideshow__overlayClose', function() {
				$w.removeClass('is-overlay-open');
				$w.find('.TextIconSlideshow__overlay').attr('aria-hidden', 'true');
			});

			setTimeout(markClamp, 200);
			$(window).on('resize', markClamp);
		}
	});

	// Distribuitori — btn class
	if ( $('.Distribuitori').length ) {
		$('.Distribuitori a').addClass('btn btn-simple');
	}

	// Popup gallery — PhotoSwipe v5
	if ( $('.popup-gallery').length ) {
		$('.popup-gallery').each(function() {
			const $gallery = $(this);
			const children = $gallery.hasClass('slick-initialized')
				? '.slick-slide:not(.slick-cloned) a'
				: 'a';
			const lightbox = new PhotoSwipeLightbox({
				gallery:    this,
				children:   children,
				pswpModule: PhotoSwipe,
			});
			lightbox.init();
		});
	}

	// Video — embed YouTube la click
	if ( $('.vid_trigger').length ) {
		$('.vid_trigger').click(function(e) {
			e.preventDefault();
			const videoUrl = $(this).attr('video-id');
			const html = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoUrl + '?autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
			$('#video_container').html(html);
			$(this).hide();
			return false;
		});
	}

	// Testimoniale — read more/less truncation
	if ( $('.widget-testimoniale').length ) {
		const showChar    = 300;
		const ellipsis    = '...';
		const moreText    = 'citește mai mult';
		const lessText    = 'citește mai puțin';

		$('.more').each(function() {
			const content     = $(this).html();
			const textContent = $(this).text();
			if ( textContent.length > showChar ) {
				const html = '<span class="more__container"><span>' + textContent.substr(0, showChar) + '</span>'
					+ '<span class="more__elipses">' + ellipsis + '</span></span>'
					+ '<span class="more__content">' + content + '</span>';
				$(this).html(html);
				$(this).after('<a href="#" class="more__link mb-30" title="' + moreText + '">' + moreText + '</a>');
			}
		});

		$('.more__link').click(function() {
			if ( $(this).hasClass('less') ) {
				$(this).removeClass('less').html(moreText);
				$(this).prev().children('.more__content').fadeToggle(500, function() {
					$(this).prev().fadeToggle(500);
				});
			} else {
				$(this).addClass('less').html(lessText);
				$(this).prev().children('.more__container').fadeToggle(500, function() {
					$(this).next().fadeToggle(500);
				});
			}
			return false;
		});
	}

	// Celco Testimoniale (widget nou) — read more/less + slideshow slick
	$('.CelcoTestimoniale').each(function() {
		const $w       = $(this);
		const showChar = 300;
		const moreText = 'citește mai mult';
		const lessText = 'citește mai puțin';

		// read-more: trunchiază conținutul lung, adaugă toggle
		$w.find('.CelcoTestimoniale__content.more').each(function() {
			const $c      = $(this);
			const content = $c.html();
			const text    = $c.text();
			if ( text.length > showChar ) {
				$c.html('<span class="more__container"><span>' + text.substr(0, showChar) + '</span><span class="more__elipses">...</span></span><span class="more__content">' + content + '</span>');
				$c.after('<a href="#" class="more__link" title="' + moreText + '">' + moreText + '</a>');
			}
		});

		$w.on('click', '.more__link', function(e) {
			e.preventDefault();
			const $link = $(this);
			if ( $link.hasClass('less') ) {
				$link.removeClass('less').html(moreText);
				$link.prev().children('.more__content').fadeToggle(400, function() { $(this).prev().fadeToggle(400); });
			} else {
				$link.addClass('less').html(lessText);
				$link.prev().children('.more__container').fadeToggle(400, function() { $(this).next().fadeToggle(400); });
			}
		});

		// slideshow (slick) — doar în mod slideshow
		if ( $w.hasClass('CelcoTestimoniale--slideshow') ) {
			const $slider = $w.find('.CelcoTestimoniale__slider');
			if ( $slider.length && ! $slider.hasClass('slick-initialized') ) {
				const show = parseInt($w.data('per-row'), 10) || 2;
				$slider.slick({
					slidesToShow:   show,
					slidesToScroll: 1,
					arrows:         true,
					dots:           false,
					infinite:       false,
					prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-mini"></i></button>',
					nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-mini"></i></button>',
					responsive: [
						{ breakpoint: 1024, settings: { slidesToShow: Math.min(show, 2) } },
						{ breakpoint: 768,  settings: { slidesToShow: 1 } }
					]
				});
			}
		}
	});

	// Commentform — Bootstrap classes pe inputs
	if ( $('#commentform').length ) {
		$('#commentform textarea').addClass('form-control');
		$('#commentform input').addClass('form-control');
		$('#commentform .form-submit input').removeClass('form-control').addClass('btn btn-primary');
	}

	// ─── Page-specific ────────────────────────────────────────────────────────

	// Filtre produse — AJAX (taxonomy category_product)
	if ( $('#filters-form').length ) {
		const $filtersForm = $('#filters-form');
		const isBcaFilters = !!window.evxBcaFilters && $filtersForm.is('[data-bca-filters]');
		let bcaSyncing = false;

		function scrollToProductList() {
			const $target = $('.product-list__row').first();

			if ( ! $target.length ) {
				return;
			}

			const scrollTop = $target.offset().top - 60;

			$('html, body').stop( true ).animate({
				scrollTop: Math.max( 0, scrollTop ),
			}, 400 );
		}

		let currentPaged = 1;

		// Actualizează ?paged= în URL (fără a pierde path-ul). Filtrele rămân doar în UI.
		function pagedUrl( paged ) {
			const url = new URL( window.location.href );
			if ( paged > 1 ) {
				url.searchParams.set( 'paged', paged );
			} else {
				url.searchParams.delete( 'paged' );
			}
			return url.toString();
		}

		function filterProductsAjax( paged, opts ) {
			paged = paged || 1;
			opts  = opts || {};
			if ( $('.product-list').hasClass('is-loading') ) return;

			$('.product-list').addClass('is-loading');

			$.ajax({
				type: 'post',
				url:  window.global.ajaxurl,
				dataType: 'json',
				data: {
					action: 'filter_products',
					nonce:  window.global.nonce,
					form:   $filtersForm.serialize(),
					paged:  paged,
				},
				success: function( data ) {
					$('.product-list').removeClass('is-loading');
					currentPaged = ( data && data.paged ) ? data.paged : paged;
					$('.product-list__row').html( ( data && data.products ) || '' );
					$('.product-list__pagination').html( ( data && data.pagination ) || '' );
					if ( ! opts.skipPush ) {
						window.history.pushState( { paged: currentPaged }, '', pagedUrl( currentPaged ) );
					}
					scrollToProductList();
				}
			}).fail(function() {
				$('.product-list').removeClass('is-loading');
			});
		}

		// Click pe paginație → navigare AJAX (link-urile rămân crawlable ca fallback).
		$(document).on('click', '.product-list__pagination a', function( e ) {
			e.preventDefault();
			const paged = parseInt( $(this).data('paged'), 10 ) || 1;
			filterProductsAjax( paged );
		});

		// Înapoi/înainte în browser → re-încarcă setul din URL.
		window.addEventListener('popstate', function() {
			const url   = new URL( window.location.href );
			const paged = parseInt( url.searchParams.get('paged'), 10 ) || 1;
			filterProductsAjax( paged, { skipPush: true } );
		});

		function updateGenericFilterHiddenInputs() {
			$filtersForm.find('.filter-term-input').each(function() {
				const terms = [];
				$(this).parent().find('.form-check-input:checked').each(function() {
					terms.push( $(this).val() );
				});
				$(this).val( terms.join(',') );
			});
		}

		function allBcaThicknessesChecked() {
			const $thicknesses = $filtersForm.find('.filter-thickness');
			return $thicknesses.length > 0 && $thicknesses.length === $thicknesses.filter(':checked').length;
		}

		function allBcaApplicationsChecked() {
			const $applications = $filtersForm.find('.filter-application');
			return $applications.length > 0 && $applications.length === $applications.filter(':checked').length;
		}

		const BCA_URL_LIST_SEP = '|';

		function getApplicationSlug( $checkbox ) {
			return String( $checkbox.data('slug') || $checkbox.attr('id') || '' );
		}

		function splitBcaUrlList( values, parseItem ) {
			if ( !values.length ) {
				return [];
			}

			if ( values.length > 1 ) {
				return values
					.map(function( value ) { return parseItem( value ); })
					.filter(function( item ) { return null !== item && false !== item && '' !== item; });
			}

			const single = String( values[0] );

			if ( single.indexOf( BCA_URL_LIST_SEP ) !== -1 ) {
				return single
					.split( BCA_URL_LIST_SEP )
					.map(function( value ) { return parseItem( value ); })
					.filter(function( item ) { return null !== item && false !== item && '' !== item; });
			}

			if ( single.indexOf(',') !== -1 ) {
				return single
					.split(',')
					.map(function( value ) { return parseItem( value ); })
					.filter(function( item ) { return null !== item && false !== item && '' !== item; });
			}

			const parsed = parseItem( single );

			return ( null !== parsed && false !== parsed && '' !== parsed ) ? [ parsed ] : [];
		}

		function getBcaUrlApplications( params ) {
			return splitBcaUrlList( params.getAll( 'aplicatie' ), function( value ) {
				const slug = decodeURIComponent( String( value ).trim() );
				return slug || null;
			} );
		}

		function getBcaUrlThicknesses( params ) {
			return splitBcaUrlList( params.getAll( 'grosime' ), function( value ) {
				const mm = parseInt( String( value ).trim(), 10 );
				return ( !isNaN( mm ) && mm > 0 ) ? mm : null;
			} );
		}

		function updateBcaFilterUrl() {
			const preserved = new URLSearchParams( window.location.search );
			const parts     = [];

			preserved.delete( 'aplicatie' );
			preserved.delete( 'grosime' );
			preserved.delete( 'nut-feder' );
			preserved.delete( 'manere' );

			preserved.forEach(function( value, key ) {
				parts.push( encodeURIComponent( key ) + '=' + encodeURIComponent( value ) );
			} );

			if ( !allBcaApplicationsChecked() ) {
				const slugs = [];

				$filtersForm.find('.filter-application:checked').each(function() {
					const slug = getApplicationSlug( $(this) );

					if ( slug ) {
						slugs.push( encodeURIComponent( slug ) );
					}
				} );

				if ( slugs.length ) {
					parts.push( 'aplicatie=' + slugs.join( BCA_URL_LIST_SEP ) );
				}
			}

			if ( !allBcaThicknessesChecked() ) {
				const mms = [];

				$filtersForm.find('.filter-thickness:checked').each(function() {
					const mm = parseInt( $(this).data('mm'), 10 );

					if ( mm ) {
						mms.push( String( mm ) );
					}
				} );

				if ( mms.length ) {
					parts.push( 'grosime=' + mms.join( BCA_URL_LIST_SEP ) );
				}
			}

			if ( isNutFederFilterActive() ) {
				parts.push( 'nut-feder=1' );
			}

			if ( isManereFilterActive() ) {
				parts.push( 'manere=1' );
			}

			const query  = parts.join('&');
			const newUrl = window.location.pathname + ( query ? '?' + query : '' ) + window.location.hash;

			history.replaceState( null, '', newUrl );
		}

		function applyBcaFiltersFromUrl() {
			const params         = new URLSearchParams( window.location.search );
			const hasAplicatie   = params.has( 'aplicatie' );
			const hasGrosime     = params.has( 'grosime' );
			const nutFederActive = params.get( 'nut-feder' ) === '1';
			const manereActive   = params.get( 'manere' ) === '1';

			bcaSyncing = true;

			if ( hasAplicatie ) {
				const slugs = new Set( getBcaUrlApplications( params ) );

				$filtersForm.find('.filter-application').each(function() {
					$(this).prop( 'checked', slugs.has( getApplicationSlug( $(this) ) ) );
				});
			} else {
				$filtersForm.find('.filter-application').prop( 'checked', true );
			}

			if ( hasGrosime ) {
				const mms = new Set( getBcaUrlThicknesses( params ) );

				$filtersForm.find('.filter-thickness').each(function() {
					const mm = parseInt( $(this).data('mm'), 10 );
					$(this).prop( 'checked', mms.has( mm ) );
				});
			} else if ( hasAplicatie ) {
				setBcaThicknessesFromApps();
			} else {
				$filtersForm.find('.filter-thickness').prop( 'checked', true );
			}

			$filtersForm.find('.filter-tongue-groove').prop( 'checked', nutFederActive );
			$filtersForm.find('.filter-handles').prop( 'checked', manereActive );

			if ( nutFederActive || manereActive ) {
				applyFeatureFiltersToThicknesses();
			}

			if ( !hasAplicatie && hasGrosime ) {
				syncBcaAppsFromThicknesses();
			}

			bcaSyncing = false;
			updateBcaDimensionHiddenInput();
			$('.filters-form__clear').removeClass('d-none');
			filterProductsAjax();
		}

		function finalizeBcaFilterChange() {
			updateBcaDimensionHiddenInput();
			updateBcaFilterUrl();
			filterProductsAjax();
		}

		function isNutFederFilterActive() {
			return $filtersForm.find('.filter-tongue-groove').is(':checked');
		}

		function isManereFilterActive() {
			return $filtersForm.find('.filter-handles').is(':checked');
		}

		function updateNutFederHiddenInput() {
			$filtersForm.find('#nut-si-feder-filter').val( isNutFederFilterActive() ? '1' : '' );
		}

		function updateManereHiddenInput() {
			$filtersForm.find('#manere-filter').val( isManereFilterActive() ? '1' : '' );
		}

		function updateBcaDimensionHiddenInput() {
			const $dimensionInput = $filtersForm.find('input[name="bca_grosime_mm"]');
			const mms = [];

			if ( !allBcaThicknessesChecked() ) {
				$filtersForm.find('.filter-thickness:checked').each(function() {
					const mm = parseInt( $(this).data('mm'), 10 ) || parseInt( $(this).val(), 10 );

					if ( mm ) {
						mms.push( mm );
					}
				});
			}

			$dimensionInput.val( mms.join(',') );
			updateNutFederHiddenInput();
			updateManereHiddenInput();
		}

		function applyFeatureFiltersToThicknesses() {
			const allowedSets = [];

			if ( isNutFederFilterActive() ) {
				allowedSets.push( window.evxBcaFilters.nutFederThicknesses || [] );
			}

			if ( isManereFilterActive() ) {
				allowedSets.push( window.evxBcaFilters.manereThicknesses || [] );
			}

			if ( !allowedSets.length ) {
				return;
			}

			let allowed = null;

			allowedSets.forEach(function( list ) {
				const next = new Set( list );

				if ( null === allowed ) {
					allowed = next;
					return;
				}

				allowed = new Set( [ ...allowed ].filter(function( mm ) {
					return next.has( mm );
				} ) );
			});

			if ( !allowed || !allowed.size ) {
				return;
			}

			$filtersForm.find('.filter-thickness').each(function() {
				const mm = parseInt( $(this).data('mm'), 10 );
				$(this).prop( 'checked', allowed.has( mm ) );
			});
		}

		function applyNutFederToThicknesses() {
			applyFeatureFiltersToThicknesses();
		}

		function setBcaThicknessesFromApps() {
			const matrix = window.evxBcaFilters;
			const thicknessSet = new Set();

			$filtersForm.find('.filter-application:checked').each(function() {
				const appId = String( $(this).val() );
				( matrix.appsToThicknesses[appId] || [] ).forEach(function(mm) {
					thicknessSet.add( mm );
				});
			});

			$filtersForm.find('.filter-thickness').each(function() {
				const mm = parseInt( $(this).data('mm'), 10 );
				$(this).prop( 'checked', thicknessSet.has( mm ) );
			});
		}

		function syncBcaThicknessesFromApps() {
			setBcaThicknessesFromApps();
			applyFeatureFiltersToThicknesses();
		}

		function syncBcaAppsFromThicknesses() {
			if ( $filtersForm.find('.filter-thickness:checked').length === 0 ) {
				$filtersForm.find('.filter-application').prop( 'checked', true );
				return;
			}

			const matrix = window.evxBcaFilters;
			const appSet = new Set();

			$filtersForm.find('.filter-thickness:checked').each(function() {
				const mm = String( $(this).data('mm') );
				( matrix.thicknessesToApps[mm] || [] ).forEach(function(appId) {
					appSet.add( appId );
				});
			});

			$filtersForm.find('.filter-application').each(function() {
				const appId = parseInt( $(this).val(), 10 );
				$(this).prop( 'checked', appSet.has( appId ) );
			});
		}

		function resetBcaFilters() {
			$filtersForm.find('.filter-application, .filter-thickness').prop( 'checked', true );
			$filtersForm.find('.filter-tongue-groove, .filter-handles').prop( 'checked', false );
			updateBcaDimensionHiddenInput();
			updateBcaFilterUrl();
		}

		function clearAllFilters( e ) {
			e.preventDefault();
			e.stopPropagation();
			if ( $('.product-list').hasClass('is-loading') ) {
				return;
			}

			$('.filters-form__clear').addClass('d-none');

			if ( isBcaFilters ) {
				resetBcaFilters();
			} else {
				$filtersForm.find('.filter-term-input').val('');
				$filtersForm.find('.form-check-input').prop('checked', false);
			}

			filterProductsAjax();
		}

		$(document).on('click', '.filters-form__clear', clearAllFilters);

		if ( isBcaFilters ) {
			const urlParams = new URLSearchParams( window.location.search );

			if ( urlParams.has('aplicatie') || urlParams.has('grosime') || urlParams.get('nut-feder') === '1' || urlParams.get('manere') === '1' ) {
				applyBcaFiltersFromUrl();
			} else {
				updateBcaDimensionHiddenInput();
			}

			$filtersForm.on('change', '.filter-tongue-groove, .filter-handles', function() {
				if ( bcaSyncing || $('.product-list').hasClass('is-loading') ) return;

				$('.filters-form__clear').removeClass('d-none');
				bcaSyncing = true;

				if ( isNutFederFilterActive() || isManereFilterActive() ) {
					applyFeatureFiltersToThicknesses();
				} else {
					$filtersForm.find('.filter-thickness').prop( 'checked', true );
				}

				bcaSyncing = false;
				finalizeBcaFilterChange();
			});

			$filtersForm.on('change', '.filter-application', function() {
				if ( bcaSyncing || $('.product-list').hasClass('is-loading') ) return;

				if ( $filtersForm.find('.filter-application:checked').length === 0 ) {
					$(this).prop('checked', true);
					return;
				}

				$('.filters-form__clear').removeClass('d-none');
				bcaSyncing = true;
				syncBcaThicknessesFromApps();
				bcaSyncing = false;
				finalizeBcaFilterChange();
			});

			$filtersForm.on('change', '.filter-thickness', function() {
				if ( bcaSyncing || $('.product-list').hasClass('is-loading') ) return;

				$('.filters-form__clear').removeClass('d-none');
				bcaSyncing = true;
				applyFeatureFiltersToThicknesses();
				syncBcaAppsFromThicknesses();
				bcaSyncing = false;
				finalizeBcaFilterChange();
			});
		} else {
			$filtersForm.find('.form-check-input').on('change', function() {
				if ( $('.product-list').hasClass('is-loading') ) return;

				$('.filters-form__clear').removeClass('d-none');
				updateGenericFilterHiddenInputs();
				filterProductsAjax();
			});
		}
	}

	// Single product — tabs mobile dropdown + sync cu nav desktop
	if ( $('.ProductTabs').length ) {
		const $productTabs      = $('.ProductTabs');
		const $dropdownToggle   = $productTabs.find('.ProductTabs__toggle');
		const productTabsScrollOffset = 15;

		function scrollToProductTabs() {
			const scrollTop = $productTabs.offset().top - productTabsScrollOffset;

			$('html, body').stop(true).animate({
				scrollTop: Math.max(0, scrollTop),
			}, 400);
		}

		$productTabs.on('click', '.ProductTabs__menuItem', function(e) {
			e.preventDefault();

			const href         = $(this).attr('href');
			const desktopTabEl = $productTabs.find('.ProductTabs__nav .nav-link[href="' + href + '"]')[0];

			if ( desktopTabEl && typeof bootstrap !== 'undefined' && bootstrap.Tab ) {
				bootstrap.Tab.getOrCreateInstance(desktopTabEl).show();
			}

			if ( $dropdownToggle.length && typeof bootstrap !== 'undefined' && bootstrap.Dropdown ) {
				const dropdown = bootstrap.Dropdown.getInstance($dropdownToggle[0]);

				if ( dropdown ) {
					dropdown.hide();
				}
			}

			scrollToProductTabs();
		});

		$productTabs.on('shown.bs.tab', '[data-bs-toggle="tab"]', function(e) {
			const $tab  = $(e.target);
			const href  = $tab.attr('href');
			const label = $tab.text().trim();

			$productTabs.find('.ProductTabs__toggleLabel').text(label);
			$productTabs.find('.ProductTabs__menuItem').removeClass('active').attr('aria-selected', 'false');
			$productTabs.find('.ProductTabs__menuItem[href="' + href + '"]').addClass('active').attr('aria-selected', 'true');
			$productTabs.find('.ProductTabs__nav .nav-link').removeClass('active').attr('aria-selected', 'false');
			$productTabs.find('.ProductTabs__nav .nav-link[href="' + href + '"]').addClass('active').attr('aria-selected', 'true');
		});
	}

	// Single product — PDF Modal: populeaza iframe-ul la deschidere si goleste la inchidere
	if ( $('#pdf-viewer-modal').length ) {
		$('#pdf-viewer-modal').on('show.bs.modal', function(e) {
			const url = $(e.relatedTarget).data('pdf-url');
			$('#pdf-viewer-iframe').attr('src', url || '');
		});
		$('#pdf-viewer-modal').on('hidden.bs.modal', function() {
			$('#pdf-viewer-iframe').attr('src', '');
		});
	}

	// Single product — slider galerie proiect (1 proiect)
	if ( $('.single-project-gallery').length ) {
		$('.single-project-gallery').slick({
			dots:      true,
			arrows:    true,
			infinite:  true,
			speed:     400,
			nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-right-open-mini"></i></button>',
			prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-left-open-mini"></i></button>',
		});
	}

	// Single product — proiecte grid (N proiecte) cu AJAX lazy-load per-row
	if ( $('.projects-grid').length ) {
		const projectCache = {};

		function loadProject( $row, projectId ) {
			const $panel = $row.find('.project-info-panel');
			const $body  = $panel.find('.project-info-panel__body');

			$panel.attr('aria-hidden', 'false').addClass('is-visible');

			if ( projectCache[projectId] ) {
				$body.empty().append( $.parseHTML(projectCache[projectId], document, false) );
				return;
			}

			$body.html('<div class="d-flex justify-content-center align-items-center h-100"><div class="loader"><div></div><div></div></div></div>');

			$.ajax({
				type: 'post',
				url:  window.global.ajaxurl,
				data: {
					action:     'get_project_info',
					nonce:      window.global.nonce,
					project_id: projectId,
				},
				success: function(response) {
					projectCache[projectId] = response;
					$body.empty().append( $.parseHTML(response, document, false) );
					$body.find('.project-panel-slideshow').slick({
						dots:         true,
						arrows:       true,
						infinite:     true,
						speed:        400,
						adaptiveHeight: false,
						nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-right-open-mini"></i></button>',
						prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-left-open-mini"></i></button>',
					});
				},
				error: function() {
					$panel.removeClass('is-visible').attr('aria-hidden', 'true');
				}
			});
		}

		$('.projects-grid').on('click', '.project-item__open', function() {
			const projectId = $(this).data('project-id');
			const $row      = $(this).closest('.projects-row');
			loadProject( $row, projectId );
		});

		$('.projects-grid').on('click', '.project-info-panel__close', function() {
			$(this).closest('.project-info-panel').removeClass('is-visible').attr('aria-hidden', 'true');
		});
	}

	// Cere cotatie btn (single product + Grid Produse) → sessionStorage produs
	$(document).on('click', '.btn-green[href*="cere-cotatie"], .ProductHero__quoteBtn[href*="cere-cotatie"], .GridProduse__card a[href*="cere-cotatie"]', function(e) {
		e.preventDefault();
		const href = $(this).attr('href');
		sessionStorage.setItem('cere-cotatie-product', href.substring(this.href.lastIndexOf('/') + 1));
		window.location.href = '/cere-cotatie/';
	});

	// Pagina cere-cotatie — restore produs din sessionStorage
	if ( $body.hasClass('page-id-2527') ) {
		if ( sessionStorage.getItem('cere-cotatie-product') !== null ) {
			$('#' + sessionStorage.getItem('cere-cotatie-product')).prop('checked', true).val('1');
			sessionStorage.removeItem('cere-cotatie-product');
		}
	}

	// Fix display distribuitor Moldova
	if ( $('.distribuitor-8275').length ) {
		$('.distribuitor-8275').css('display', 'none');
	}

});

})(jQuery);


/* ===========================================================================
 * Celco Paralax — scroll-driven video scrubbing (rulează pe FRONTEND)
 * Long-slide : scroll-ul derulează video.currentTime (scrub) + crossfade text.
 * Easy-slide : scroll-ul alege pasul; clipul rulează singur până la timecode.
 * Mobil      : carusel de stills (slick). Folosește stills server-side (ffmpeg,
 *              atribut data-still); fallback la captură client-side.
 * =========================================================================== */
(function ($) {
    'use strict';

    function initCelcoParalax() {
        var sections = document.querySelectorAll('.CelcoParalax');
        if (!sections.length) return;
        var mqDesktop = window.matchMedia('(min-width: 1024px)');

        sections.forEach(function (section) {
            var video  = section.querySelector('.CelcoParalax__video');
            var items  = [].slice.call(section.querySelectorAll('.CelcoParalax__item'));
            var mobile = section.querySelector('.CelcoParalax__mobile');
            var hint   = section.querySelector('.CelcoParalax__scrollHint');
            if (!video || !items.length) return;

            var mode  = section.getAttribute('data-mode') || 'long';
            var pps   = parseInt(section.getAttribute('data-pps'), 10) || 150;
            var times = items.map(function (el) { return parseFloat(el.getAttribute('data-time')) || 0; });

            var serverDur = parseFloat(section.getAttribute('data-duration')) || 0;
            var st = { duration: serverDur, raf: null, destroyDesktop: null, destroyMobile: null };

            function setActive(idx) {
                items.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
            }
            function activeIndexForTime(t) {
                var idx = 0;
                for (var i = 0; i < times.length; i++) { if (t >= times[i] - 0.01) idx = i; }
                return idx;
            }

            // ── DESKTOP ──────────────────────────────────────────────────────
            function setupDesktop() {
                var dur = st.duration || 1;
                var vh  = window.innerHeight;

                var trackPx = (mode === 'easy')
                    ? vh + items.length * Math.round(vh * 0.85)
                    : vh + Math.round(dur * pps);
                section.style.height = trackPx + 'px';

                // Forțează decodarea primului cadru (evită box negru când nu e poster)
                var nudged = false;
                function nudgeFirstFrame() {
                    if (nudged) return; nudged = true;
                    try { video.currentTime = 0.05; } catch (e) {}
                }
                if (video.readyState >= 2) nudgeFirstFrame();
                else video.addEventListener('loadeddata', nudgeFirstFrame, { once: true });

                var lastT = -1, lastIdx = -1, lastStep = -1;

                function progress() {
                    var rect  = section.getBoundingClientRect();
                    var total = section.offsetHeight - vh;
                    if (total <= 0) return 0;
                    return Math.min(1, Math.max(0, (-rect.top) / total));
                }

                function frameLong() {
                    st.raf = null;
                    var p = progress();
                    var t = p * dur;
                    if (Math.abs(t - lastT) > 0.01) { try { video.currentTime = t; } catch (e) {} lastT = t; }
                    var idx = activeIndexForTime(t);
                    if (idx !== lastIdx) { setActive(idx); lastIdx = idx; }
                    if (hint) hint.classList.toggle('is-hidden', p > 0.04);
                }

                function frameEasy() {
                    st.raf = null;
                    var p = progress();
                    var step = Math.min(items.length - 1, Math.floor(p * items.length));
                    if (step !== lastStep) {
                        var target = times[step];
                        if (target > video.currentTime + 0.05) {
                            var stopAt = function () {
                                if (video.currentTime >= target - 0.05) {
                                    video.pause();
                                    video.removeEventListener('timeupdate', stopAt);
                                }
                            };
                            video.addEventListener('timeupdate', stopAt);
                            var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
                        } else {
                            try { video.currentTime = target; } catch (e) {} // reverse = salt instant
                        }
                        setActive(step);
                        lastStep = step;
                    }
                }

                var onFrame = (mode === 'easy') ? frameEasy : frameLong;
                function schedule() { if (!st.raf) st.raf = requestAnimationFrame(onFrame); }

                var io = new IntersectionObserver(function (entries) {
                    entries.forEach(function (en) {
                        if (en.isIntersecting) { window.addEventListener('scroll', schedule, { passive: true }); schedule(); }
                        else { window.removeEventListener('scroll', schedule); }
                    });
                }, { rootMargin: '200px 0px' });
                io.observe(section);

                st.destroyDesktop = function () {
                    io.disconnect();
                    window.removeEventListener('scroll', schedule);
                    if (st.raf) { cancelAnimationFrame(st.raf); st.raf = null; }
                    section.style.height = '';
                };
            }

            // ── MOBIL ────────────────────────────────────────────────────────
            function captureFrames(track) {
                var pending = [].slice.call(track.querySelectorAll('.CelcoParalax__mslide'))
                    .filter(function (s) { return !s.__hasStill; });
                if (!pending.length) return;
                var srcEl = video.querySelector('source');
                var src   = srcEl ? srcEl.src : video.currentSrc;
                if (!src) return;
                var v = document.createElement('video');
                v.muted = true; v.playsInline = true; v.preload = 'auto'; v.src = src;
                var canvas = document.createElement('canvas');
                var i = 0;
                function next() {
                    if (i >= pending.length) { v.removeAttribute('src'); try { v.load(); } catch (e) {} return; }
                    var slide = pending[i];
                    var onSeeked = function () {
                        v.removeEventListener('seeked', onSeeked);
                        try {
                            canvas.width = v.videoWidth; canvas.height = v.videoHeight;
                            canvas.getContext('2d').drawImage(v, 0, 0);
                            slide.__img.src = canvas.toDataURL('image/jpeg', 0.82);
                        } catch (e) {}
                        i++; next();
                    };
                    v.addEventListener('seeked', onSeeked);
                    try { v.currentTime = Math.min(slide.__time, (v.duration || slide.__time)); }
                    catch (e) { i++; next(); }
                }
                v.addEventListener('loadedmetadata', next, { once: true });
            }

            function setupMobile() {
                var track = document.createElement('div');
                track.className = 'CelcoParalax__mtrack';
                var poster = video.getAttribute('poster') || '';
                items.forEach(function (item, i) {
                    var slide = document.createElement('div');
                    slide.className = 'CelcoParalax__mslide';
                    var img = document.createElement('img');
                    img.className = 'CelcoParalax__mimg';
                    img.alt = '';
                    var still = item.getAttribute('data-still') || '';
                    if (still) { img.src = still; slide.__hasStill = true; }
                    else if (poster) { img.src = poster; }
                    var txt = document.createElement('div');
                    txt.innerHTML = item.innerHTML;
                    slide.appendChild(img);
                    slide.appendChild(txt);
                    slide.__img = img; slide.__time = times[i];
                    track.appendChild(slide);
                });
                mobile.appendChild(track);

                if ($.fn && $.fn.slick) {
                    $(track).slick({ slidesToShow: 1, arrows: false, dots: true, infinite: false, adaptiveHeight: true });
                }
                captureFrames(track);

                st.destroyMobile = function () {
                    try { if ($(track).hasClass('slick-initialized')) $(track).slick('unslick'); } catch (e) {}
                    mobile.innerHTML = '';
                };
            }

            // ── Comutare desktop/mobil ────────────────────────────────────────
            function activate() {
                if (mqDesktop.matches) {
                    if (st.destroyMobile) { st.destroyMobile(); st.destroyMobile = null; }
                    if (!st.destroyDesktop) setupDesktop();
                } else {
                    if (st.destroyDesktop) { st.destroyDesktop(); st.destroyDesktop = null; }
                    if (!st.destroyMobile) setupMobile();
                }
            }

            function start() { if (!st.duration) st.duration = video.duration || 0; activate(); }
            // Cu durata de pe server (ffprobe) pornim IMEDIAT — nu depindem de
            // loadedmetadata (care întârzie când video-ul e sub fold), deci sticky
            // primește înălțimea la timp.
            if (st.duration) activate();
            else if (video.readyState >= 1 && video.duration) start();
            else video.addEventListener('loadedmetadata', start, { once: true });
            try { video.load(); } catch (e) {} // forțează încărcarea metadata + prim cadru

            var rt;
            window.addEventListener('resize', function () {
                clearTimeout(rt);
                rt = setTimeout(function () {
                    activate();
                    if (mqDesktop.matches && st.destroyDesktop) { st.destroyDesktop(); st.destroyDesktop = null; setupDesktop(); }
                }, 200);
            });
        });
    }

    $(function () { initCelcoParalax(); });
})(jQuery);


/* ===========================================================================
 * Celco Paralax — motor FRAME-SEQUENCE (canvas scrub, à la p4)
 * Secvență de imagini desenată pe canvas, legată de scroll prin GSAP ScrollTrigger
 * (pin pe stage) + Lenis (smooth). Capitole cu overlay/nav + snapping pe ancore.
 * Config din data-* pe .CelcoParalax--frames; overlays/nav randate server-side.
 * =========================================================================== */
(function ($) {
    'use strict';

    function initCelcoFrameScrub() {
        var sections = document.querySelectorAll('.CelcoParalax--frames');
        if (!sections.length || typeof gsap === 'undefined') return;
        gsap.registerPlugin(ScrollTrigger);

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Un singur Lenis pe pagină (smooth scroll), punte către ScrollTrigger.
        var lenis = window.__evxLenis || null;
        if (!reduce && !lenis && typeof Lenis !== 'undefined') {
            lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
            window.__evxLenis = lenis;
            lenis.on('scroll', ScrollTrigger.update);
            gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
            gsap.ticker.lagSmoothing(0);
        }

        sections.forEach(function (section) { setupSection(section, lenis, reduce); });
    }

    function setupSection(section, lenis, reduce) {
        var BP = 1024;
        var count  = parseInt(section.getAttribute('data-count'), 10) || 0;
        if (count < 2) return;
        var baseUrl = section.getAttribute('data-frames-url') || '';
        var ext     = section.getAttribute('data-ext') || 'webp';
        var hasMob  = section.getAttribute('data-mobile') === '1';
        var srcW    = parseInt(section.getAttribute('data-source-w'), 10) || 16;
        var srcH    = parseInt(section.getAttribute('data-source-h'), 10) || 9;
        var spf     = parseInt(section.getAttribute('data-spf'), 10) || 30;
        var scrub   = parseFloat(section.getAttribute('data-scrub'));
        if (!(scrub >= 0)) scrub = 1.0;                            // amortizare urmărire cadru (mai mare = mai lin)
        var scrollMode = section.getAttribute('data-scroll') || 'snap';   // free | snap | chapters
        if (reduce) scrollMode = 'free';
        var jumpMs = parseInt(section.getAttribute('data-jump-ms'), 10);           // durată tranziție capitole (ms); <=0 = viteză constantă
        if (isNaN(jumpMs)) jumpMs = 1200;
        var easeAccel = parseFloat(section.getAttribute('data-ease-accel'));       // fracție accelerare la plecare
        if (!(easeAccel > 0)) easeAccel = 0.08;                                    // mai mic = pleacă mai rapid
        var easeDecel = parseFloat(section.getAttribute('data-ease-decel'));       // fracție decelerare la aterizare
        if (!(easeDecel > 0)) easeDecel = 0.28;                                    // mai mare = aterizare mai lină
        var coolMs = parseInt(section.getAttribute('data-cooldown-ms'), 10);       // pauză între salturi (ms)
        if (!(coolMs >= 0)) coolMs = 250;                                          // mai mic = pornire mai promptă
        var touchPx = parseInt(section.getAttribute('data-touch-px'), 10);         // prag gest touch (px)
        if (!(touchPx > 0)) touchPx = 30;                                          // mai mic = mai sensibil
        var textLeft = section.classList.contains('CelcoParalax--text-left');

        var stage   = section.querySelector('.CelcoParalax__stage');
        var canvas  = section.querySelector('.CelcoParalax__canvas');
        var overlays = [].slice.call(section.querySelectorAll('.CelcoParalax__overlay'));
        var navItems = [].slice.call(section.querySelectorAll('.CelcoParalax__navItem'));
        var progBar = section.querySelector('.CelcoParalax__progress > i');
        var hintEl  = section.querySelector('.CelcoParalax__scrollHint');
        var loaderEl = section.querySelector('.CelcoParalax__loader');
        var loaderPct = section.querySelector('.CelcoParalax__loaderPct');
        if (!stage || !canvas) return;

        var ctx = canvas.getContext('2d');
        var useMobile = hasMob && window.innerWidth < BP;
        var dir = baseUrl + '/' + (useMobile ? 'mobile' : 'desktop');
        var framePath = function (i) {
            return dir + '/frame_' + String(i).padStart(4, '0') + '.' + ext;
        };

        // Capitole (intervale + ancore) din JSON.
        var chapters = [];
        try {
            var raw = section.querySelector('.CelcoParalax__chapters');
            if (raw) chapters = JSON.parse(raw.textContent) || [];
        } catch (e) {}
        var anchors = chapters.map(function (c) { return c.anchor; });
        var anchorSet = {}; anchors.forEach(function (a) { anchorSet[a] = true; });

        // ── State + canvas ────────────────────────────────────────────────────
        var images = new Array(count);
        var state = { frame: 0, chapter: -1 };
        var viewW = 0, viewH = 0, dpr = 1;
        var mobileFit = null;   // layout mobil cache-uit {dx,dy,w,h} (imagine sus, text sub ea)

        // Header „scroll_sticky" acoperă stage-ul pinuit → rezervăm înălțimea lui în partea de sus,
        // ca imaginea/textul/nav să înceapă sub el (0 pentru celelalte comportamente).
        var headerInset = 0;
        function computeHeaderInset() {
            var hdr = document.getElementById('site-header');
            if (!hdr || (hdr.getAttribute('data-header-behavior') || '') !== 'scroll_sticky') return 0;
            return Math.round(hdr.getBoundingClientRect().height) || 0;
        }

        function resizeCanvas() {
            dpr = Math.min(window.devicePixelRatio || 1, 2);
            viewW = stage.clientWidth; viewH = stage.clientHeight;
            canvas.width = Math.round(viewW * dpr);
            canvas.height = Math.round(viewH * dpr);
            canvas.style.width = viewW + 'px';
            canvas.style.height = viewH + 'px';
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            headerInset = computeHeaderInset();
            section.style.setProperty('--cp-top-inset', headerInset + 'px');   // desktop overlay/nav (CSS)
            layoutMobile();
            drawFrame(state.frame);
        }

        // Mobil: imaginea SUS de tot, textul CHIAR sub finalul imaginii. Calculează geometria
        // o dată (la resize + schimbare de capitol), nu în fiecare cadru → fără thrash de layout.
        function layoutMobile() {
            var navEl = section.querySelector('.CelcoParalax__nav');
            if (viewW >= BP || !stage) {
                overlays.forEach(function (el) { el.style.top = ''; el.style.bottom = ''; });  // reset desktop
                if (navEl) { navEl.style.top = ''; navEl.style.bottom = ''; }
                mobileFit = null;
                return;
            }
            // Stivă verticală: [imagine sus] → gap1 → [text] → gap2 → [nav]. Spații calculate
            // proporțional cu înălțimea ecranului; nav chiar sub text (taie golul alb din mijloc).
            var mTop = 14 + headerInset;                                        // sub header-ul sticky
            var gap1 = Math.max(22, Math.min(56, Math.round(viewH * 0.04)));    // imagine → text
            var gap2 = Math.max(14, Math.min(30, Math.round(viewH * 0.022)));   // text → nav (mai mic)
            var bottomMin = 16;
            // Înălțimea maximă a textului peste toate capitolele → imagine + nav de poziție stabilă.
            var textH = 0;
            overlays.forEach(function (el) { textH = Math.max(textH, el.getBoundingClientRect().height); });
            textH = Math.ceil(textH) || 160;
            var navH = navEl ? Math.ceil(navEl.getBoundingClientRect().height) : 24;
            // Imaginea nu depășește spațiul rămas peste gap1+text+gap2+nav+jos (pe device scurt scade).
            var maxImageH = Math.max(40, viewH - mTop - gap1 - textH - gap2 - navH - bottomMin);
            var sm = Math.min(viewW / srcW, maxImageH / srcH);
            var wm = srcW * sm, hm = srcH * sm;
            mobileFit = { dx: (viewW - wm) / 2, dy: mTop, w: wm, h: hm };       // imagine sus de tot
            var textTop = mTop + hm + gap1;                                     // textul sub imagine (gap1)
            var navTop  = textTop + textH + gap2;                              // nav chiar sub text (gap2)
            overlays.forEach(function (el) { el.style.top = Math.round(textTop) + 'px'; el.style.bottom = 'auto'; });
            if (navEl) { navEl.style.top = Math.round(navTop) + 'px'; navEl.style.bottom = 'auto'; }
        }

        // „Contain" ancorat: rezervă o coloană de text (desktop) / imagine-sus + text-dedesubt (mobil).
        function computeFit() {
            if (viewW < BP) {
                if (mobileFit) return mobileFit;
                var smf = Math.min(viewW / srcW, (viewH * 0.5) / srcH);   // fallback până la layoutMobile
                return { dx: (viewW - srcW * smf) / 2, dy: 12, w: srcW * smf, h: srcH * smf };
            }
            var vInset = 28;
            var textZone = Math.max(340, viewW * 0.40);
            var boxW = Math.max(40, viewW - textZone);
            var boxH = viewH - headerInset - vInset * 2;   // sub header-ul sticky
            var s = Math.min(boxW / srcW, boxH / srcH);
            var w = srcW * s, h = srcH * s;
            var stripX = textLeft ? textZone : 0;         // strip pe partea opusă textului
            return { dx: stripX + (boxW - w) / 2, dy: headerInset + (viewH - headerInset - h) / 2, w: w, h: h };
        }

        function drawFrame(n) {
            var idx = Math.max(0, Math.min(count - 1, Math.round(n)));
            var img = images[idx];
            if (!img || !img.complete || !img.naturalWidth) {
                for (var j = idx - 1; j >= 0; j--) {
                    var c = images[j];
                    if (c && c.complete && c.naturalWidth) { img = c; break; }
                }
            }
            if (!img || !img.complete || !img.naturalWidth) return;
            ctx.clearRect(0, 0, viewW, viewH);
            var f = computeFit();
            ctx.drawImage(img, f.dx, f.dy, f.w, f.h);
        }

        // ── Preload progresiv (prioritizat + throttled + pre-decode) ──────────
        var loaded = 0;
        var READY = Math.min(count, 20);
        var loadPromises = new Array(count);
        function loadFrame(i, onEach) {
            if (loadPromises[i]) return loadPromises[i];   // deja pornit/încărcat → nu re-fetch
            loadPromises[i] = new Promise(function (res) {
                var img = new Image();
                img.decoding = 'async';
                var done = function () { loaded++; if (onEach) onEach(); res(); };
                img.onload = function () {
                    // pre-decode → desenarea nu mai sacadează (memoria o gestionează browserul)
                    if (img.decode) { img.decode().then(done, done); } else { done(); }
                };
                img.onerror = done;
                img.src = framePath(i);
                images[i] = img;
            });
            return loadPromises[i];
        }
        // Pre-încarcă + pre-decodează toate cadrele de pe traseul unui salt de capitol.
        function decodePath(a, b) {
            var lo = Math.max(0, Math.min(a | 0, b | 0));
            var hi = Math.min(count - 1, Math.max(a | 0, b | 0));
            var ps = [];
            for (var i = lo; i <= hi; i++) ps.push(loadFrame(i));
            return Promise.all(ps);
        }
        function preload() {
            var first = [];
            for (var i = 0; i < READY; i++) first.push(loadFrame(i, function () {
                if (loaderPct) loaderPct.textContent = Math.round(loaded / READY * 100);
            }));
            return Promise.all(first).then(function () { streamRest(); });
        }
        // Restul cadrelor: ancorele capitolelor întâi, apoi în ordine; concurență limitată.
        // Pe conexiuni lente / Save-Data încarcă mai puțin agresiv.
        function streamRest() {
            var conn = navigator.connection || {};
            var slow = conn.saveData || /(^|\-)(slow-2g|2g)$/.test(conn.effectiveType || '');
            var CONC = slow ? 2 : 6;

            var order = [], seen = {};
            var add = function (f) { if (f >= READY && f < count && !seen[f]) { seen[f] = 1; order.push(f); } };
            chapters.forEach(function (c) { add(c.range[0]); add(c.anchor); add(c.range[1]); });  // ancore întâi
            for (var i = READY; i < count; i++) add(i);                                            // apoi în ordine

            var ptr = 0, active = 0;
            function loadOne(idx) {
                active++;
                loadFrame(idx).then(function () {
                    active--;
                    if (Math.round(state.frame) === idx) drawFrame(state.frame);
                    pump();
                });
            }
            function pump() {
                while (active < CONC && ptr < order.length) { loadOne(order[ptr++]); }
            }
            pump();
        }

        // ── Chapters / overlays ────────────────────────────────────────────────
        function chapterForFrame(f) {
            for (var i = 0; i < chapters.length; i++) {
                var r = chapters[i].range;
                if (f >= r[0] && f <= r[1]) return i;
            }
            return f < (chapters[0] ? chapters[0].range[0] : 0) ? 0 : chapters.length - 1;
        }
        function setActiveChapter(i) {
            if (i === state.chapter || i < 0) return;
            state.chapter = i;
            overlays.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
            navItems.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
            // Textul activ (deci înălțimea lui) s-a schimbat → repoziționează imaginea deasupra lui.
            layoutMobile();
        }

        // ── Hartă scroll neliniară (dwell pe ancore) + snapping ────────────────
        var HOLD = 0; // dwell dezactivat (scrub constant); păstrat pentru extindere
        var uPts = [], fPts = [], U = 1, anchorU = {};
        (function buildMap() {
            var u = 0;
            for (var i = 0; i < count; i++) {
                uPts.push(u); fPts.push(i);
                if (anchorSet[i]) {
                    anchorU[i] = u + HOLD / 2;
                    if (HOLD > 0) { u += HOLD; uPts.push(u); fPts.push(i); }
                }
                if (i < count - 1) u += 1;
            }
            U = u || 1;
        })();
        function scrollLength() { return U * spf; }
        function progressToFrame(p) {
            var u = Math.max(0, Math.min(U, p * U));
            for (var k = 1; k < uPts.length; k++) {
                if (u <= uPts[k]) {
                    var u0 = uPts[k - 1], u1 = uPts[k];
                    var t = (u1 === u0) ? 0 : (u - u0) / (u1 - u0);
                    return fPts[k - 1] + (fPts[k] - fPts[k - 1]) * t;
                }
            }
            return count - 1;
        }
        function frameToProgress(f) {
            if (anchorU[f] != null) return anchorU[f] / U;
            for (var k = 0; k < fPts.length; k++) { if (fPts[k] >= f) return uPts[k] / U; }
            return 1;
        }

        var st = null;
        var chapterJumpAbs = null;   // setat în modul „chapters" → aceeași tranziție ca wheel/touch
        var skipping = false;        // lock cât timp rulează butonul „skip"

        function jumpToChapter(i) {
            if (!st || !chapters[i]) return;
            // În „chapters" folosim saltul unificat (durată scalată + easeInOut + lock + pre-decode).
            if (chapterJumpAbs) { chapterJumpAbs(i); return; }
            var p = frameToProgress(chapters[i].anchor);
            var y = st.start + p * (st.end - st.start);
            if (lenis) lenis.scrollTo(y, { duration: 1.1 });
            else window.scrollTo({ top: y, behavior: 'smooth' });
        }
        navItems.forEach(function (el, i) { el.addEventListener('click', function () { jumpToChapter(i); }); });

        function nearestAnchorFrame(f) {
            var best = anchors[0], bd = Infinity;
            anchors.forEach(function (a) { var d = Math.abs(a - f); if (d < bd) { bd = d; best = a; } });
            return best;
        }

        // ── ScrollTrigger (pin stage + scrub) ─────────────────────────────────
        function initScroll() {
            // În „chapters" mișcarea e deja o animație eased (lenis.scrollTo), deci
            // amortizarea scrub e redundantă și adaugă ezitare la start → o reducem mult.
            var stScrub = (scrollMode === 'chapters') ? Math.min(scrub, 0.25) : scrub;
            st = ScrollTrigger.create({
                trigger: stage,
                start: 'top top',
                end: function () { return '+=' + scrollLength(); },
                pin: stage,
                pinSpacing: true,
                scrub: reduce ? true : stScrub,
                invalidateOnRefresh: true,
                onUpdate: function (self) {
                    var f = progressToFrame(self.progress);
                    state.frame = f;
                    drawFrame(f);
                    setActiveChapter(chapterForFrame(Math.round(f)));
                    if (progBar) progBar.style.width = (self.progress * 100) + '%';
                    if (hintEl) hintEl.classList.toggle('is-hidden', self.progress > 0.02);
                },
                onToggle: function (self) {
                    // Ascunde bara flotantă din footer (.bottom-bar) cât timp paralax-ul e activ.
                    document.body.classList.toggle('cp-hide-bottombar', self.isActive);
                }
            });

            // ── Snap la oprire: se așază pe ancora cea mai apropiată ───────────
            if (scrollMode === 'snap' && lenis) {
                var snapTO = null, snapping = false, peak = 0, lastY = 0, lastT = 0;
                lenis.on('scroll', function () {
                    if (snapping || skipping || !st.isActive) return;
                    var y = lenis.scroll, now = performance.now();
                    if (lastT) { var dt = now - lastT; if (dt > 0) peak = Math.max(peak, Math.abs(y - lastY) / dt); }
                    lastY = y; lastT = now;
                    clearTimeout(snapTO);
                    snapTO = setTimeout(function () {
                        var vel = peak; peak = 0; lastT = 0;
                        if (vel < 0.15) return;                                  // scrub lent → stă liber
                        var tgt = nearestAnchorFrame(state.frame);
                        if (Math.abs(tgt - state.frame) <= 2) return;
                        snapping = true;
                        var yy = st.start + frameToProgress(tgt) * (st.end - st.start);
                        lenis.scrollTo(yy, { duration: 0.7, easing: function (t) { return 1 - Math.pow(1 - t, 3); },
                            onComplete: function () { snapping = false; } });
                    }, 140);
                });
            }

            // ── Derulare pe capitole: un gest = un capitol (blocat în tranziție) ─
            else if (scrollMode === 'chapters' && lenis && chapters.length) {
                var jumping = false, coolUntil = 0;
                // Profil trapezoidal de viteză, ASIMETRIC: accelerare scurtă la plecare (pIn,
                // setabilă din widget → „Accelerare la plecare"; mai mic = pornire mai bruscă/
                // rapidă) → croazieră la viteză constantă → decelerare lungă/lină la aterizare
                // (pOut fix). Aria totală = 1 (distanța saltului), deci durata rămâne cea cerută.
                var easeCruise = function (t) {
                    var pIn  = Math.max(0.02, Math.min(0.45, easeAccel));   // accelerare (plecare)
                    var pOut = Math.max(0.10, Math.min(0.45, easeDecel));   // decelerare (aterizare)
                    var V = 1 / (1 - (pIn + pOut) / 2);                     // viteza de croazieră (normalizată)
                    if (t < pIn)       return ( V / (2 * pIn) ) * t * t;               // accelerare
                    if (t <= 1 - pOut) return 0.5 * V * pIn + V * (t - pIn);           // croazieră (viteză constantă)
                    var u = 1 - t;
                    return 1 - ( V / (2 * pOut) ) * u * u;                             // decelerare
                };

                var baseDur = jumpMs / 1000;   // durata unui salt tipic (o lățime de capitol)
                var avgDist = Math.max(1, count / Math.max(1, chapters.length));  // cadre/capitol
                function jumpTo(idx, direct) {
                    jumping = true;
                    var last = chapters.length - 1;
                    // Primul capitol → primul cadru; ultimul → ultimul cadru (rulează până la capăt);
                    // restul → ancora (mijlocul intervalului).
                    var targetFrame = idx === 0 ? 0 : ( idx === last ? ( count - 1 ) : chapters[idx].anchor );
                    var startFrame = state.frame;
                    // Pre-decodează traseul ÎN PARALEL — NU blocăm pornirea, ca să nu apară
                    // latență la gest (senzația de „a trebuit să dau scroll de 2 ori"). easeInOut
                    // pornește lent, deci cadrele apucă să se decodeze până accelerează mișcarea.
                    decodePath(startFrame, targetFrame);
                    var frameDist = Math.abs(targetFrame - startFrame);
                    var dur;
                    if (jumpMs <= 0) {
                        // VITEZĂ CONSTANTĂ: durata ∝ număr de cadre. Capitolele nu-s egale ca
                        // lungime, deci nici tranzițiile — unul de 60 cadre durează 4× unul de 15.
                        // Fără plafon: capitolele lungi chiar durează mai mult. (~0.08s/cadru.)
                        dur = Math.min(10, Math.max(0.2, frameDist * 0.08));
                    } else {
                        // Durată ȚINTĂ: baza × (distanță / salt tipic) → toate salturile durează la fel.
                        dur = Math.min(4.5, Math.max(0.35, baseDur * frameDist / avgDist));
                    }
                    var y = st.start + frameToProgress(targetFrame) * (st.end - st.start);
                    lenis.scrollTo(y, {
                        lock: true, duration: dur, easing: direct ? function (t) { return t; } : easeCruise,
                        onComplete: function () { jumping = false; coolUntil = performance.now() + coolMs; }
                    });
                }
                // dir: +1 jos, -1 sus. Întoarce true dacă a preluat gestul (îl blocăm).
                function tryJump(dir) {
                    if (jumping || performance.now() < coolUntil) return true;   // în tranziție/cooldown
                    var cur = state.chapter < 0 ? 0 : state.chapter;
                    var idx = cur + dir;
                    if (idx < 0 || idx >= chapters.length) return false;         // margine → eliberează pagina
                    jumpTo(idx);
                    return true;
                }

                // Butoanele de capitol (nav) → salt absolut, LINIAR (direct, fără rampă), aceeași durată.
                chapterJumpAbs = function (idx) {
                    if (jumping || performance.now() < coolUntil) return;        // în tranziție/cooldown
                    if (idx < 0 || idx >= chapters.length || idx === state.chapter) return;
                    jumpTo(idx, true);   // nav-click: liniar, direct (fără accelerare/decelerare)
                };

                // Wheel (mouse / trackpad)
                var onWheel = function (e) {
                    if (!st.isActive) return;
                    var dir = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
                    if (!dir) return;
                    if (tryJump(dir)) { e.preventDefault(); }  // margine → NU preventDefault (derulare normală)
                };
                window.addEventListener('wheel', onWheel, { passive: false });

                // Touch (touchscreen / pad)
                var tY = null;
                window.addEventListener('touchstart', function (e) {
                    tY = (e.touches && e.touches.length) ? e.touches[0].clientY : null;
                }, { passive: true });
                window.addEventListener('touchmove', function (e) {
                    if (!st.isActive || tY === null) return;
                    var dy = tY - e.touches[0].clientY;         // >0 = swipe sus = derulare jos
                    if (Math.abs(dy) < touchPx) return;
                    if (tryJump(dy > 0 ? 1 : -1)) { e.preventDefault(); tY = null; }
                }, { passive: false });
                window.addEventListener('touchend', function () { tY = null; }, { passive: true });

                // Săgeți sus/jos (accesibilitate, când widgetul e activ)
                window.addEventListener('keydown', function (e) {
                    if (!st.isActive) return;
                    if (e.key === 'ArrowDown' || e.key === 'PageDown') { if (tryJump(1)) e.preventDefault(); }
                    else if (e.key === 'ArrowUp' || e.key === 'PageUp') { if (tryJump(-1)) e.preventDefault(); }
                });
            }

            // ── Buton „skip" — Full (sare peste secțiune) / Play (rulează automat) ──
            var skipBtn = section.querySelector('.CelcoParalax__skip');
            if (skipBtn) {
                skipBtn.addEventListener('click', function () {
                    if (!st) return;
                    var mode = skipBtn.getAttribute('data-skip') || 'full';
                    skipping = true;
                    var done = function () { skipping = false; };
                    // Ținta = topul următorului element Elementor din pagină. Pin-spacer-ul
                    // ScrollTrigger face ca fundul secțiunii să fie ≈ st.end (ultimul cadru),
                    // deci NU ne bazăm pe el; căutăm elementul următor real.
                    var targetY;
                    var widget = section.closest('.elementor-widget') || section;
                    var node = widget.nextElementSibling;
                    while (node && node.offsetHeight === 0) { node = node.nextElementSibling; }
                    if (!node) {
                        var box = widget.closest('.elementor-column, .e-con, .elementor-top-section, .elementor-section');
                        node = box ? box.nextElementSibling : null;
                        while (node && node.offsetHeight === 0) { node = node.nextElementSibling; }
                    }
                    if (node) {
                        targetY = Math.round(window.scrollY + node.getBoundingClientRect().top);
                    } else {
                        // fallback: o înălțime de ecran dincolo de sfârșitul pin-ului
                        targetY = Math.round(st.end + window.innerHeight);
                    }
                    if (mode === 'play') {
                        // Rulează automat prin tot paralax-ul, apoi continuă în secțiunea următoare.
                        var dur = Math.min(20, Math.max(5, count * 0.08));
                        if (lenis) lenis.scrollTo(targetY, { duration: dur, force: true, lock: true, easing: function (t) { return t; }, onComplete: done });
                        else { window.scrollTo({ top: targetY, behavior: 'smooth' }); done(); }
                    } else {
                        // Full skip: coboară rapid până în secțiunea următoare.
                        if (lenis) lenis.scrollTo(targetY, { duration: 0.5, force: true, lock: true, easing: function (t) { return 1 - Math.pow(1 - t, 3); }, onComplete: done });
                        else { window.scrollTo({ top: targetY, behavior: 'auto' }); done(); }
                    }
                });
            }

            ScrollTrigger.refresh();
        }

        // ── Boot ───────────────────────────────────────────────────────────────
        var ro = new ResizeObserver(function () {
            resizeCanvas();
            if (st) ScrollTrigger.refresh();
        });
        ro.observe(stage);

        resizeCanvas();
        drawFrame(0);
        preload().then(function () {
            if (loaderEl) { loaderEl.classList.add('is-hidden'); }
            setActiveChapter(0);
            drawFrame(0);
            initScroll();
        });
    }

    $(function () { initCelcoFrameScrub(); });
})(jQuery);


/* ===========================================================================
 * Celco P4 — port VERBATIM al p4/index.html (mecanism + valori exact ca p4).
 * Cadre fixe din uploads/celco-frames/vp4/{frames,frames_mobile}; doar capitolele
 * vin din widget. Scopat la .CelcoP4 (nu global) ca să nu strice pagina.
 * =========================================================================== */
(function ($) {
    'use strict';

    function initCelcoP4() {
        var sections = document.querySelectorAll('.CelcoP4');
        if (!sections.length || typeof gsap === 'undefined') return;
        gsap.registerPlugin(ScrollTrigger);
        sections.forEach(function (root) { setupP4(root); });
    }

    function setupP4(root) {
        // ── CONFIG (exact p4; doar sursa + capitolele vin din widget) ─────────
        var FRAME_COUNT = parseInt(root.getAttribute('data-count'), 10) || 0;
        if (FRAME_COUNT < 2) return;
        var FRAMES_BASE = root.getAttribute('data-frames') || '';
        var FRAME_DIR   = (window.innerWidth <= 760) ? 'frames_mobile' : 'frames';
        var FRAME_PATH  = function (i) { return FRAMES_BASE + '/' + FRAME_DIR + '/frame_' + String(i).padStart(4, '0') + '.webp'; };
        var SLOW_AT_ANCHORS = false;
        var SNAP_TO_KEYFRAMES = true;
        var SNAP_MIN_VELOCITY = 0.15;
        var SNAP_DEADZONE = 2;
        var SOURCE_W = parseInt(root.getAttribute('data-sw'), 10) || 1275;
        var SOURCE_H = parseInt(root.getAttribute('data-sh'), 10) || 1080;
        var SCROLL_PER_FRAME = (window.innerWidth <= 760) ? 50 : 30;
        var MOBILE_BP = 760;
        var LAYOUT = { textZone: 0.40, textZoneMin: 340, rightInset: 0, vInset: 28,
                       mRightInset: 0, mTopInset: 16, mBottomRoom: 170 };
        var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"/><polyline points="13 6 19 12 13 18"/></svg>';

        var CHAPTERS = [];
        try { var rawC = root.querySelector('.CelcoP4__chapters'); if (rawC) CHAPTERS = JSON.parse(rawC.textContent) || []; } catch (e) {}
        if (!CHAPTERS.length) return;

        var stage = root.querySelector('.CelcoP4__stage');
        var canvas = root.querySelector('.CelcoP4__canvas');
        var ctx = canvas.getContext('2d');
        var overlaysEl = root.querySelector('.CelcoP4__overlays');
        var navEl = root.querySelector('.CelcoP4__nav');
        var progressBar = root.querySelector('.CelcoP4__progress > i');
        var hintEl = root.querySelector('.CelcoP4__hint');
        var loaderEl = root.querySelector('.CelcoP4__loader');
        var barEl = loaderEl.querySelector('.CelcoP4__bar > i');
        var pctEl = loaderEl.querySelector('.CelcoP4__pct > span');

        // ── PRELOAD (gate scroll până e decodat primul batch) ─────────────────
        var images = new Array(FRAME_COUNT);
        var loaded = 0;
        var READY_BATCH = Math.min(FRAME_COUNT, 20);
        function loadFrame(i, onEach) {
            return new Promise(function (res) {
                var img = new Image();
                img.onload = img.onerror = function () { loaded++; if (onEach) onEach(); res(); };
                img.src = FRAME_PATH(i);
                images[i] = img;
            });
        }
        function preload() {
            var first = [];
            for (var i = 0; i < READY_BATCH; i++) first.push(loadFrame(i, function () {
                var pct = Math.round((loaded / READY_BATCH) * 100);
                barEl.style.width = pct + '%'; pctEl.textContent = pct;
            }));
            return Promise.all(first).then(function () {
                for (var k = READY_BATCH; k < FRAME_COUNT; k++) {
                    (function (idx) {
                        loadFrame(idx, function () { if (Math.round(state.frame) === idx) drawFrame(state.frame); });
                    })(k);
                }
            });
        }

        // ── CANVAS (cover/contain fit + DPR) ──────────────────────────────────
        var viewW = 0, viewH = 0, dpr = 1;
        function resizeCanvas() {
            dpr = Math.min(window.devicePixelRatio || 1, 2);
            viewW = stage.clientWidth; viewH = stage.clientHeight;
            canvas.width = Math.round(viewW * dpr); canvas.height = Math.round(viewH * dpr);
            canvas.style.width = viewW + 'px'; canvas.style.height = viewH + 'px';
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            drawFrame(state.frame);
        }
        function computeFit() {
            if (viewW <= MOBILE_BP) {
                var boxW = viewW - LAYOUT.mRightInset * 2;
                var boxH = viewH - LAYOUT.mTopInset - LAYOUT.mBottomRoom;
                var s = Math.min(boxW / SOURCE_W, boxH / SOURCE_H);
                var w = SOURCE_W * s, h = SOURCE_H * s;
                return { dx: (viewW - w) / 2, dy: LAYOUT.mTopInset, w: w, h: h };
            }
            var textZone = Math.max(LAYOUT.textZoneMin, viewW * LAYOUT.textZone);
            var bW = Math.max(40, viewW - textZone - LAYOUT.rightInset);
            var bH = viewH - LAYOUT.vInset * 2;
            var sc = Math.min(bW / SOURCE_W, bH / SOURCE_H);
            var ww = SOURCE_W * sc, hh = SOURCE_H * sc;
            return { dx: viewW - LAYOUT.rightInset - ww, dy: (viewH - hh) / 2, w: ww, h: hh };
        }
        function drawFrame(n) {
            var idx = Math.max(0, Math.min(FRAME_COUNT - 1, Math.round(n)));
            var img = images[idx];
            if (!img || !img.complete || !img.naturalWidth) {
                for (var j = idx - 1; j >= 0; j--) { var c = images[j]; if (c && c.complete && c.naturalWidth) { img = c; break; } }
            }
            if (!img || !img.complete || !img.naturalWidth) return;
            ctx.clearRect(0, 0, viewW, viewH);
            var f = computeFit();
            ctx.drawImage(img, f.dx, f.dy, f.w, f.h);
        }

        // ── STATE + capitole/overlay/nav ──────────────────────────────────────
        var state = { frame: 0, chapter: -1 };
        var overlays = [], navItems = [];
        function buildUI() {
            CHAPTERS.forEach(function (c, i) {
                var o = document.createElement('div');
                o.className = 'CelcoP4__overlay';
                var html = '<h2>' + c.title + '</h2>';
                if (c.sub) html += '<div class="CelcoP4__sub">' + c.sub + '</div>';
                if (c.cta) html += '<a class="CelcoP4__cta" href="' + c.cta.url + '"><span class="CelcoP4__ico">' + ARROW + '</span><span class="CelcoP4__txt">' + c.cta.txt + '</span></a>';
                o.innerHTML = html;
                overlaysEl.appendChild(o);

                var b = document.createElement('button');
                b.type = 'button'; b.className = 'CelcoP4__navItem';
                var navLabel = String(c.title).replace(/<br\s*\/?>/gi, ' ');
                b.setAttribute('aria-label', navLabel);
                b.innerHTML = '<span class="CelcoP4__dot"></span><span class="CelcoP4__label">' + navLabel + '</span>';
                b.addEventListener('click', function () { jumpToChapter(i); });
                navEl.appendChild(b);
            });
            overlays = [].slice.call(overlaysEl.children);
            navItems = [].slice.call(navEl.children);
        }
        function chapterForFrame(f) {
            for (var i = 0; i < CHAPTERS.length; i++) { var r = CHAPTERS[i].range; if (f >= r[0] && f <= r[1]) return i; }
            return f < CHAPTERS[0].range[0] ? 0 : CHAPTERS.length - 1;
        }
        function setActiveChapter(i) {
            if (i === state.chapter) return;
            state.chapter = i;
            overlays.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
            navItems.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
        }

        // ── Hartă scroll (dwell pe ancore) + snapping ─────────────────────────
        var ANCHOR_HOLD = 18;
        var anchorSet = {}; CHAPTERS.forEach(function (c) { anchorSet[c.anchor] = true; });
        var uPts = [], fPts = [], U = 1, anchorU = {};
        (function buildScrollMap() {
            var hold = SLOW_AT_ANCHORS ? ANCHOR_HOLD : 0, u = 0;
            for (var i = 0; i < FRAME_COUNT; i++) {
                uPts.push(u); fPts.push(i);
                if (anchorSet[i]) { anchorU[i] = u + hold / 2; if (hold > 0) { u += hold; uPts.push(u); fPts.push(i); } }
                if (i < FRAME_COUNT - 1) u += 1;
            }
            U = u || 1;
        })();
        function scrollLength() { return U * SCROLL_PER_FRAME; }
        function progressToFrame(p) {
            var u = Math.max(0, Math.min(U, p * U));
            for (var k = 1; k < uPts.length; k++) {
                if (u <= uPts[k]) { var u0 = uPts[k - 1], u1 = uPts[k]; var t = (u1 === u0) ? 0 : (u - u0) / (u1 - u0); return fPts[k - 1] + (fPts[k] - fPts[k - 1]) * t; }
            }
            return FRAME_COUNT - 1;
        }
        function frameToProgress(f) {
            if (anchorU[f] != null) return anchorU[f] / U;
            for (var k = 0; k < fPts.length; k++) { if (fPts[k] >= f) return uPts[k] / U; }
            return 1;
        }

        var st = null, lenis = null;
        function jumpToChapter(i) {
            if (!st) return;
            var p = frameToProgress(CHAPTERS[i].anchor);
            var y = st.start + p * (st.end - st.start);
            lenis ? lenis.scrollTo(y, { duration: 1.1 }) : window.scrollTo({ top: y, behavior: 'smooth' });
        }
        var anchorFrames = CHAPTERS.map(function (c) { return c.anchor; });
        function nearestAnchorFrame(f) {
            var best = anchorFrames[0], bd = Infinity;
            anchorFrames.forEach(function (a) { var d = Math.abs(a - f); if (d < bd) { bd = d; best = a; } });
            return best;
        }
        function anchorScrollY(frame) { return st.start + frameToProgress(frame) * (st.end - st.start); }

        // ── SCROLL — Lenis + ScrollTrigger pin & scrub (exact p4) ─────────────
        function initScroll() {
            lenis = window.__evxLenis || null;
            if (!lenis && typeof Lenis !== 'undefined') {
                lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1, smoothWheel: true });
                window.__evxLenis = lenis;
                lenis.on('scroll', ScrollTrigger.update);
                gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
                gsap.ticker.lagSmoothing(0);
            }

            var snapTO = null, snapping = false, peakVel = 0, lastY = 0, lastT = 0;
            (lenis || { on: function () {} }).on('scroll', function () {
                ScrollTrigger.update();
                if (!SNAP_TO_KEYFRAMES || snapping || !st) return;
                var y = lenis.scroll, now = performance.now();
                if (lastT) { var dt = now - lastT; if (dt > 0) peakVel = Math.max(peakVel, Math.abs(y - lastY) / dt); }
                lastY = y; lastT = now;
                clearTimeout(snapTO);
                snapTO = setTimeout(function () {
                    var vel = peakVel; peakVel = 0; lastT = 0;
                    var tgt = nearestAnchorFrame(state.frame);
                    if (vel < SNAP_MIN_VELOCITY) return;
                    if (Math.abs(tgt - state.frame) <= SNAP_DEADZONE) return;
                    snapping = true;
                    lenis.scrollTo(anchorScrollY(tgt), { duration: 0.7, easing: function (t) { return 1 - Math.pow(1 - t, 3); },
                        onComplete: function () { snapping = false; } });
                }, 140);
            });

            st = ScrollTrigger.create({
                trigger: stage, start: 'top top', end: function () { return '+=' + scrollLength(); },
                pin: stage, pinSpacing: true, scrub: 0.6, invalidateOnRefresh: true,
                onUpdate: function (self) {
                    var f = progressToFrame(self.progress);
                    state.frame = f; drawFrame(f);
                    setActiveChapter(chapterForFrame(Math.round(f)));
                    if (progressBar) progressBar.style.width = (self.progress * 100) + '%';
                    if (hintEl) hintEl.classList.toggle('is-gone', self.progress > 0.02);
                }
            });
            ScrollTrigger.refresh();
        }

        // ── BOOT ──────────────────────────────────────────────────────────────
        var refreshQueued = false;
        var ro = new ResizeObserver(function () {
            resizeCanvas();
            if (st && !refreshQueued) { refreshQueued = true; requestAnimationFrame(function () { refreshQueued = false; ScrollTrigger.refresh(); }); }
        });
        ro.observe(stage);

        buildUI();
        resizeCanvas();
        drawFrame(0);
        preload().then(function () {
            loaderEl.classList.add('is-hidden');
            setTimeout(function () { loaderEl.style.display = 'none'; }, 650);
            navEl.classList.add('is-ready');
            initScroll();
            setActiveChapter(0);
            drawFrame(0);
        });
    }

    $(function () { initCelcoP4(); });
})(jQuery);


/* ===========================================================================
 * Celco Proiecte — mod slideshow (slick). Grid-ul e pur CSS.
 * =========================================================================== */
(function ($) {
    $(function () {
        if (!$.fn || !$.fn.slick) return;
        $('.CelcoProiecte__slider').each(function () {
            var $s = $(this);
            if ($s.hasClass('slick-initialized')) return;
            var show = parseInt($s.closest('.CelcoProiecte').data('per-row'), 10) || 3;
            $s.slick({
                slidesToShow: show,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-mini"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-mini"></i></button>',
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: Math.min(show, 2) } },
                    { breakpoint: 576, settings: { slidesToShow: 1 } }
                ]
            });
        });
    });
})(jQuery);


/* ===========================================================================
 * Celco Presentation Banner — count-up statistici la intrarea în viewport.
 * Numărul real e în text (fallback no-JS); JS animează 0 → data-count.
 * =========================================================================== */
(function ($) {
    'use strict';

    function fmt(n) { return n.toLocaleString('en-US'); }

    var SPEEDS = { fast: 850, smooth: 1600, slow: 2800 };

    function animate($num, dur) {
        var target = parseInt($num.attr('data-count'), 10);
        if (isNaN(target)) return;
        var $ind = $num.find('.CelcoPB__statInd');
        var indHtml = $ind.length ? $ind.prop('outerHTML') : '';
        var start = null;
        function step(ts) {
            if (!start) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
            $num.html(fmt(Math.round(eased * target)) + indHtml);
            if (p < 1) requestAnimationFrame(step);
            else $num.html(fmt(target) + indHtml);
        }
        requestAnimationFrame(step);
    }

    $(function () {
        var stats = [].slice.call(document.querySelectorAll('.CelcoPB__stats'));
        if (!stats.length) return;

        // setare inițială la 0 (păstrând indicatorul)
        $('.CelcoPB__statNumber[data-count]').each(function () {
            var $n = $(this);
            var $ind = $n.find('.CelcoPB__statInd');
            $n.html('0' + ($ind.length ? $ind.prop('outerHTML') : ''));
        });

        function run(group) {
            var dur = SPEEDS[group.getAttribute('data-speed')] || SPEEDS.smooth;
            $(group).find('.CelcoPB__statNumber[data-count]').each(function () { animate($(this), dur); });
        }

        if (!('IntersectionObserver' in window)) { stats.forEach(run); return; }

        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
                if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
            });
        }, { threshold: 0.4 });

        stats.forEach(function (s) { io.observe(s); });
    });
})(jQuery);


/* ===========================================================================
 * Celco Elemente Slideshow — mod slideshow (slick). Grid-ul e pur CSS.
 * =========================================================================== */
(function ($) {
    $(function () {
        if (!$.fn || !$.fn.slick) return;
        $('.CelcoElements--slideshow .CelcoElements__slider').each(function () {
            var $s = $(this);
            if ($s.hasClass('slick-initialized')) return;
            var show = parseInt($s.closest('.CelcoElements').data('per-row'), 10) || 2;
            $s.slick({
                slidesToShow: show,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-mini"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-mini"></i></button>',
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: Math.min(show, 2) } },
                    { breakpoint: 768, settings: { slidesToShow: 1 } }
                ]
            });
        });
    });
})(jQuery);


/* ===========================================================================
 * Celco Image Carusel — carusel logo-uri (slick, autoplay opțional).
 * =========================================================================== */
(function ($) {
    $(function () {
        if (!$.fn || !$.fn.slick) return;
        $('.CelcoImages--slideshow .CelcoImages__slider').each(function () {
            var $s = $(this);
            if ($s.hasClass('slick-initialized')) return;
            var $sec = $s.closest('.CelcoImages');
            var show = parseInt($sec.data('per-row'), 10) || 6;
            var autoplay = $sec.data('autoplay') == 1;
            // puține imagini (≤ pe rând) → lăsăm rândul flex centrat din CSS, fără slick
            if ($s.children().length <= show) return;
            $s.slick({
                slidesToShow: show,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: autoplay,
                autoplaySpeed: 2200,
                speed: 700,
                pauseOnHover: true,
                cssEase: 'linear',
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: Math.min(show, 4) } },
                    { breakpoint: 768, settings: { slidesToShow: 3 } },
                    { breakpoint: 480, settings: { slidesToShow: 2 } }
                ]
            });
        });
    });
})(jQuery);


/* ===========================================================================
 * Celco Prezentare Activitati — slideshow imagini (slick, fade + autoplay).
 * =========================================================================== */
(function ($) {
    $(function () {
        if (!$.fn || !$.fn.slick) return;
        $('.CelcoActivitati__slider').each(function () {
            var $s = $(this);
            if ($s.hasClass('slick-initialized')) return;
            if ($s.children().length < 2) return; // o singură imagine → fără carusel
            $s.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                fade: true,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3500,
                speed: 700,
                pauseOnHover: true
            });
        });
    });
})(jQuery);


/* ===========================================================================
 * Celco Redare Postari — mod slideshow (slick). Grid-ul e pur CSS.
 * =========================================================================== */
(function ($) {
    $(function () {
        if (!$.fn || !$.fn.slick) return;
        $('.CelcoPosts--slideshow .CelcoPosts__slider').each(function () {
            var $s = $(this);
            if ($s.hasClass('slick-initialized')) return;
            var show = parseInt($s.closest('.CelcoPosts').data('per-row'), 10) || 3;
            $s.slick({
                slidesToShow: show,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-mini"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-mini"></i></button>',
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: Math.min(show, 2) } },
                    { breakpoint: 768, settings: { slidesToShow: 1 } }
                ]
            });
        });
    });
})(jQuery);

/* ===========================================================================
 * Celco Flipbook — cititor PDF cu răsfoire 2D (PDF.js randează paginile pe
 * canvas → StPageFlip le răsfoiește). Bibliotecile vin din CDN (enqueue în
 * widget). Controale: prev/next, pagina X/Y, zoom, fullscreen, thumbnails.
 * =========================================================================== */
(function () {
    'use strict';

    function waitFor(test, cb, tries) {
        tries = (tries === undefined) ? 120 : tries;
        if (test()) { cb(); return; }
        if (tries <= 0) { return; }
        setTimeout(function () { waitFor(test, cb, tries - 1); }, 100);
    }

    function initFlipbook(root) {
        if (root._fbInited) { return; }
        root._fbInited = true;
        var url = root.getAttribute('data-pdf');
        if (!url) { return; }

        var bookEl    = root.querySelector('.CelcoFlipbook__book');
        var viewport  = root.querySelector('.CelcoFlipbook__viewport');
        var loader    = root.querySelector('.CelcoFlipbook__loader');
        var loaderPct = root.querySelector('.CelcoFlipbook__loaderPct');
        var curEl     = root.querySelector('.CelcoFlipbook__cur');
        var totalEl   = root.querySelector('.CelcoFlipbook__total');
        var thumbsWrap  = root.querySelector('.CelcoFlipbook__thumbs');
        var thumbsInner = root.querySelector('.CelcoFlipbook__thumbsInner');

        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

        pdfjsLib.getDocument(url).promise.then(function (pdf) {
            var n = pdf.numPages;
            var images = new Array(n);
            var ratio = 1.414;   // A4 până citim prima pagină
            var rendered = 0;

            function renderPage(i) {
                return pdf.getPage(i).then(function (page) {
                    var vp1 = page.getViewport({ scale: 1 });
                    if (i === 1) { ratio = vp1.height / vp1.width; }
                    var scale = Math.min(2.5, 1000 / vp1.width);
                    var vp = page.getViewport({ scale: scale });
                    var canvas = document.createElement('canvas');
                    canvas.width  = Math.round(vp.width);
                    canvas.height = Math.round(vp.height);
                    return page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise.then(function () {
                        images[i - 1] = canvas.toDataURL('image/jpeg', 0.85);
                        rendered++;
                        if (loaderPct) { loaderPct.textContent = Math.round((rendered / n) * 100); }
                    });
                });
            }

            var chain = Promise.resolve();
            for (var i = 1; i <= n; i++) {
                (function (i) { chain = chain.then(function () { return renderPage(i); }); })(i);
            }
            return chain.then(function () { build(images, ratio); });
        }).catch(function () {
            if (loader) { loader.textContent = 'Nu am putut încărca PDF-ul.'; }
        });

        function build(images, ratio) {
            if (loader) { loader.classList.add('is-hidden'); }

            var pageW = 500;
            var pageH = Math.round(pageW * ratio);

            var pageFlip = new St.PageFlip(bookEl, {
                width: pageW, height: pageH,
                size: 'stretch',
                minWidth: 250, maxWidth: 2200, minHeight: 300, maxHeight: 2800,
                maxShadowOpacity: 0.4, showCover: false, usePortrait: true,
                mobileScrollSupport: false, drawShadow: true, useMouseEvents: true
            });
            pageFlip.loadFromImages(images);
            root._pageFlip = pageFlip;

            if (totalEl) { totalEl.textContent = pageFlip.getPageCount(); }
            if (curEl)   { curEl.textContent = 1; }

            // Limitează lățimea cărții cât să încapă pe înălțimea stage-ului (--fb-height).
            function fit() {
                var stageH = viewport.clientHeight || 600;
                bookEl.style.maxWidth = Math.round(2 * (stageH / ratio)) + 'px';
                pageFlip.update();
            }
            fit();

            function setThumbActive(idx) {
                if (!thumbsInner) { return; }
                var items = thumbsInner.children;
                for (var k = 0; k < items.length; k++) { items[k].classList.toggle('is-active', k === idx); }
            }

            pageFlip.on('flip', function (e) {
                if (curEl) { curEl.textContent = e.data + 1; }
                setThumbActive(e.data);
            });

            var prev = root.querySelector('.CelcoFlipbook__prev');
            var next = root.querySelector('.CelcoFlipbook__next');
            if (prev) { prev.addEventListener('click', function () { pageFlip.flipPrev(); }); }
            if (next) { next.addEventListener('click', function () { pageFlip.flipNext(); }); }

            // Zoom (transform CSS + pan prin scroll)
            var scale = 1;
            function applyZoom() {
                bookEl.style.transform = 'scale(' + scale + ')';
                bookEl.style.transformOrigin = 'center top';
                if (viewport) { viewport.style.overflow = scale > 1 ? 'auto' : ''; }
                root.classList.toggle('is-zoomed', scale > 1);
            }
            var zi = root.querySelector('.CelcoFlipbook__zoomIn');
            var zo = root.querySelector('.CelcoFlipbook__zoomOut');
            if (zi) { zi.addEventListener('click', function () { scale = Math.min(3, scale + 0.25); applyZoom(); }); }
            if (zo) { zo.addEventListener('click', function () { scale = Math.max(1, scale - 0.25); applyZoom(); }); }

            // Fullscreen
            var fsBtn = root.querySelector('.CelcoFlipbook__fs');
            if (fsBtn) {
                fsBtn.addEventListener('click', function () {
                    if (document.fullscreenElement) { document.exitFullscreen(); }
                    else if (root.requestFullscreen) { root.requestFullscreen(); }
                });
                document.addEventListener('fullscreenchange', function () {
                    root.classList.toggle('is-fullscreen', document.fullscreenElement === root);
                    setTimeout(fit, 140);
                });
            }

            // Thumbnails
            var thumbsBtn = root.querySelector('.CelcoFlipbook__thumbsToggle');
            if (thumbsBtn && thumbsWrap && thumbsInner) {
                images.forEach(function (src, k) {
                    var b = document.createElement('button');
                    b.type = 'button';
                    b.className = 'CelcoFlipbook__thumb' + (k === 0 ? ' is-active' : '');
                    var img = document.createElement('img');
                    img.src = src; img.loading = 'lazy'; img.alt = 'Pagina ' + (k + 1);
                    var num = document.createElement('span'); num.className = 'CelcoFlipbook__thumbNum'; num.textContent = k + 1;
                    b.appendChild(img); b.appendChild(num);
                    b.addEventListener('click', function () { pageFlip.flip(k); });
                    thumbsInner.appendChild(b);
                });
                thumbsBtn.addEventListener('click', function () {
                    var willOpen = thumbsWrap.hasAttribute('hidden');
                    if (willOpen) { thumbsWrap.removeAttribute('hidden'); } else { thumbsWrap.setAttribute('hidden', ''); }
                    thumbsBtn.classList.toggle('is-active', willOpen);
                });
            }

            var to;
            window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(fit, 200); });

            root.tabIndex = 0;
            root.addEventListener('keydown', function (e) {
                if (e.key === 'ArrowLeft') { pageFlip.flipPrev(); }
                else if (e.key === 'ArrowRight') { pageFlip.flipNext(); }
            });
        }
    }

    function libsReady() { return window.pdfjsLib && window.St && window.St.PageFlip; }

    // Construiește shell-ul unui flipbook (aceeași structură ca render/celco-flipbook.php).
    function buildShell(pdf, height) {
        var el = document.createElement('div');
        el.className = 'CelcoFlipbook';
        el.setAttribute('data-pdf', pdf);
        el.style.setProperty('--fb-height', height || '86vh');
        el.innerHTML =
            '<div class="CelcoFlipbook__toolbar">' +
                '<div class="CelcoFlipbook__nav">' +
                    '<button type="button" class="CelcoFlipbook__btn CelcoFlipbook__prev" aria-label="Pagina anterioară"><i class="icon-arrow-left"></i></button>' +
                    '<span class="CelcoFlipbook__pageInfo"><span class="CelcoFlipbook__cur">1</span> / <span class="CelcoFlipbook__total">–</span></span>' +
                    '<button type="button" class="CelcoFlipbook__btn CelcoFlipbook__next" aria-label="Pagina următoare"><i class="icon-arrow-right"></i></button>' +
                '</div>' +
                '<div class="CelcoFlipbook__tools">' +
                    '<button type="button" class="CelcoFlipbook__btn CelcoFlipbook__zoomOut" aria-label="Micșorează"><span>&minus;</span></button>' +
                    '<button type="button" class="CelcoFlipbook__btn CelcoFlipbook__zoomIn" aria-label="Mărește"><span>+</span></button>' +
                    '<button type="button" class="CelcoFlipbook__btn CelcoFlipbook__thumbsToggle" aria-label="Miniaturi"><svg width="16" height="16" viewBox="0 0 16 16"><rect x="1" y="1" width="6" height="6" rx="1"/><rect x="9" y="1" width="6" height="6" rx="1"/><rect x="1" y="9" width="6" height="6" rx="1"/><rect x="9" y="9" width="6" height="6" rx="1"/></svg></button>' +
                    '<a class="CelcoFlipbook__btn CelcoFlipbook__download" href="' + pdf + '" download target="_blank" rel="noopener" aria-label="Descarcă PDF"><i class="icon-download"></i></a>' +
                '</div>' +
            '</div>' +
            '<div class="CelcoFlipbook__stage">' +
                '<div class="CelcoFlipbook__loader"><span class="CelcoFlipbook__loaderPct">0</span>%</div>' +
                '<div class="CelcoFlipbook__viewport"><div class="CelcoFlipbook__book"></div></div>' +
                '<div class="CelcoFlipbook__thumbs" hidden><div class="CelcoFlipbook__thumbsInner"></div></div>' +
            '</div>';
        return el;
    }

    // Popup cu flipbook pentru un PDF (folosit de promote box-ul hero, sursă PDF).
    function openFlipbookModal(pdf) {
        var overlay = document.createElement('div');
        overlay.className = 'CelcoFlipbook__modal';
        var inner = document.createElement('div');
        inner.className = 'CelcoFlipbook__modalInner';
        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'CelcoFlipbook__modalClose';
        close.setAttribute('aria-label', 'Închide');
        close.innerHTML = '<i class="icon-cancel"></i>';
        var shell = buildShell(pdf, '86vh');
        inner.appendChild(close);
        inner.appendChild(shell);
        overlay.appendChild(inner);
        document.body.appendChild(overlay);
        document.body.classList.add('cp-flipbook-open');
        requestAnimationFrame(function () { overlay.classList.add('is-open'); });

        waitFor(libsReady, function () { initFlipbook(shell); });

        function destroy() {
            if (shell._pageFlip) { try { shell._pageFlip.destroy(); } catch (e) {} }
            overlay.remove();
            document.body.classList.remove('cp-flipbook-open');
            document.removeEventListener('keydown', onKey);
        }
        function onKey(e) { if (e.key === 'Escape') { destroy(); } }
        close.addEventListener('click', destroy);
        overlay.addEventListener('click', function (e) { if (e.target === overlay) { destroy(); } });
        document.addEventListener('keydown', onKey);
    }

    // Miniatură = prima pagină a PDF-ului (pentru thumbnail-ul din promote box).
    function renderPdfThumb(wrap) {
        var pdf = wrap.getAttribute('data-flipbook-thumb');
        var canvas = wrap.querySelector('canvas');
        if (!pdf || !canvas) { return; }
        pdfjsLib.getDocument(pdf).promise.then(function (doc) {
            return doc.getPage(1);
        }).then(function (page) {
            var vp1 = page.getViewport({ scale: 1 });
            var scale = Math.min(2, 600 / vp1.width);
            var vp = page.getViewport({ scale: scale });
            canvas.width = Math.round(vp.width);
            canvas.height = Math.round(vp.height);
            return page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise;
        }).then(function () {
            wrap.classList.add('is-ready');
        }).catch(function () {});
    }

    function boot() {
        var books  = document.querySelectorAll('.CelcoFlipbook');
        var thumbs = document.querySelectorAll('[data-flipbook-thumb]');
        var triggers = document.querySelectorAll('[data-flipbook-pdf]');

        if (!books.length && !thumbs.length && !triggers.length) { return; }

        // Deschidere popup la click pe un promote box cu PDF.
        document.addEventListener('click', function (e) {
            var t = e.target.closest('[data-flipbook-pdf]');
            if (!t) { return; }
            e.preventDefault();
            waitFor(libsReady, function () { openFlipbookModal(t.getAttribute('data-flipbook-pdf')); });
        });

        waitFor(function () { return window.pdfjsLib; }, function () {
            [].forEach.call(thumbs, function (w) { renderPdfThumb(w); });
        });

        if (books.length) {
            waitFor(libsReady, function () {
                [].forEach.call(books, function (b) { initFlipbook(b); });
            });
        }
    }

    window.EVXFlipbook = { init: initFlipbook, buildShell: buildShell, openModal: openFlipbookModal };

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
})();
